const updateState = (context, state) => {
  state && context.internals.setState(JSON.parse(state), {
    permanent: true
  });
};

function pipeline() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return arg => {
    return fns.reduce((acc, fn) => {
      return fn(acc);
    }, arg);
  };
}

const sidMap = new Map();

let count = 0;
const generateId = () => String(new Date().getTime() + count++);

const createRemoteSettingsSid = (name, tag) => "".concat(name, "-").concat(tag);
const createRemoteSettingsPromiseSid = (name, tag) => "".concat(name, "-").concat(tag, "-promise");
const createSharedStorageSid = function () {
  let uuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : generateId();
  return "shared-storage-".concat(uuid);
};
const createLocationSid = options => "location-".concat(options.pathname, "-").concat(options.search);
const createGenerateResultSid = function () {
  let uuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : generateId();
  return "generate-result-".concat(uuid);
};
const createPublishEventSid = function () {
  let uuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : generateId();
  return "publish-event-".concat(uuid);
};
const createResolveSid = function () {
  let uuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : generateId();
  return "resolve-".concat(uuid);
};
const createFetchAlbumsSid = function () {
  let uuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : generateId();
  return "fetch-media-albums-".concat(uuid);
};
const createRequestPermissionSid = function () {
  let uuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : generateId();
  return "request-permission-".concat(uuid);
};
const createFetchMediaAssetsSid = function () {
  let uuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : generateId();
  return "fetch-media-assets-".concat(uuid);
};

const handleCustomEvent = async _ref => {
  let {
    data,
    sid
  } = _ref;
  const resolver = sidMap.get(sid);
  if (resolver) {
    sidMap.delete(sid);
    resolver(JSON.parse(data));
  }
};

var eventStorm = {};

var createVirtualModel;
var createModel;
Object.defineProperty(eventStorm, "__esModule", {
  value: !0
});
const t = {},
  e = _ref => {
    let {
      options: e = {},
      ...r
    } = _ref;
    return {
      lastState: "lastState" in r ? r.lastState : t,
      options: e,
      subscribers: []
    };
  },
  r = () => {},
  n = t => "function" == typeof t,
  o = t => Array.isArray(t),
  i = t => void 0 === t,
  a = t => "object" == typeof t && t,
  u = {},
  c = t => u[t],
  s = (t, r, n) => !(t => !!u[t])(t) && ((t, r, n) => (u[t] = e({
    lastState: r,
    options: n
  }), c(t)))(t, r, n),
  f = async (t, e, _ref2) => {
    let {
      force: r,
      ...o
    } = _ref2;
    const i = c(t),
      a = n(e) ? e(i.lastState) : e,
      u = (s = a) && n(s.then) ? await a : a;
    var s;
    const {
      lastState: f
    } = i;
    i.lastState = u;
    const l = o.fireDuplicates || i.options.fireDuplicates;
    i.subscribers.forEach(_ref3 => {
      let {
        callback: t
      } = _ref3;
      return l || r || u !== f ? t(u, o) : void 0;
    });
  };
let l = 0;
function p(t) {
  for (var e = arguments.length, r = Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) r[n - 1] = arguments[n];
  throw Error("[Immer] minified error nr: " + t + (r.length ? " " + r.map(function (t) {
    return "'" + t + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function d(t) {
  return !!t && !!t[Y];
}
function b(t) {
  return !!t && (function (t) {
    if (!t || "object" != typeof t) return !1;
    var e = Object.getPrototypeOf(t);
    if (null === e) return !0;
    var r = Object.hasOwnProperty.call(e, "constructor") && e.constructor;
    return r === Object || "function" == typeof r && Function.toString.call(r) === tt;
  }(t) || Array.isArray(t) || !!t[Q] || !!t.constructor[Q] || g(t) || P(t));
}
function h(t, e, r) {
  void 0 === r && (r = !1), 0 === y(t) ? (r ? Object.keys : et)(t).forEach(function (n) {
    r && "symbol" == typeof n || e(n, t[n], t);
  }) : t.forEach(function (r, n) {
    return e(n, r, t);
  });
}
function y(t) {
  var e = t[Y];
  return e ? e.i > 3 ? e.i - 4 : e.i : Array.isArray(t) ? 1 : g(t) ? 2 : P(t) ? 3 : 0;
}
function v(t, e) {
  return 2 === y(t) ? t.has(e) : Object.prototype.hasOwnProperty.call(t, e);
}
function m(t, e, r) {
  var n = y(t);
  2 === n ? t.set(e, r) : 3 === n ? (t.delete(e), t.add(r)) : t[e] = r;
}
function g(t) {
  return X && t instanceof Map;
}
function P(t) {
  return q && t instanceof Set;
}
function O(t) {
  return t.o || t.t;
}
function S(t) {
  if (Array.isArray(t)) return Array.prototype.slice.call(t);
  var e = rt(t);
  delete e[Y];
  for (var r = et(e), n = 0; n < r.length; n++) {
    var o = r[n],
      i = e[o];
    !1 === i.writable && (i.writable = !0, i.configurable = !0), (i.get || i.set) && (e[o] = {
      configurable: !0,
      writable: !0,
      enumerable: i.enumerable,
      value: t[o]
    });
  }
  return Object.create(Object.getPrototypeOf(t), e);
}
function w(t, e) {
  return void 0 === e && (e = !1), E(t) || d(t) || !b(t) || (y(t) > 1 && (t.set = t.add = t.clear = t.delete = j), Object.freeze(t), e && h(t, function (t, e) {
    return w(e, !0);
  }, !0)), t;
}
function j() {
  p(2);
}
function E(t) {
  return null == t || "object" != typeof t || Object.isFrozen(t);
}
function D(t) {
  var e = nt[t];
  return e || p(18, t), e;
}
function $() {
  return G;
}
function A(t, e) {
  e && (D("Patches"), t.u = [], t.s = [], t.v = e);
}
function x(t) {
  _(t), t.p.forEach(N), t.p = null;
}
function _(t) {
  t === G && (G = t.l);
}
function I(t) {
  return G = {
    p: [],
    l: G,
    h: t,
    m: !0,
    _: 0
  };
}
function N(t) {
  var e = t[Y];
  0 === e.i || 1 === e.i ? e.j() : e.O = !0;
}
function k(t, e) {
  e._ = e.p.length;
  var r = e.p[0],
    n = void 0 !== t && t !== r;
  return e.h.g || D("ES5").S(e, t, n), n ? (r[Y].P && (x(e), p(4)), b(t) && (t = F(e, t), e.l || z(e, t)), e.u && D("Patches").M(r[Y].t, t, e.u, e.s)) : t = F(e, r, []), x(e), e.u && e.v(e.u, e.s), t !== H ? t : void 0;
}
function F(t, e, r) {
  if (E(e)) return e;
  var n = e[Y];
  if (!n) return h(e, function (o, i) {
    return M(t, n, e, o, i, r);
  }, !0), e;
  if (n.A !== t) return e;
  if (!n.P) return z(t, n.t, !0), n.t;
  if (!n.I) {
    n.I = !0, n.A._--;
    var o = 4 === n.i || 5 === n.i ? n.o = S(n.k) : n.o;
    h(3 === n.i ? new Set(o) : o, function (e, i) {
      return M(t, n, o, e, i, r);
    }), z(t, o, !1), r && t.u && D("Patches").R(n, r, t.u, t.s);
  }
  return n.o;
}
function M(t, e, r, n, o, i) {
  if (d(o)) {
    var a = F(t, o, i && e && 3 !== e.i && !v(e.D, n) ? i.concat(n) : void 0);
    if (m(r, n, a), !d(a)) return;
    t.m = !1;
  }
  if (b(o) && !E(o)) {
    if (!t.h.F && t._ < 1) return;
    F(t, o), e && e.A.l || z(t, o);
  }
}
function z(t, e, r) {
  void 0 === r && (r = !1), t.h.F && t.m && w(e, r);
}
function R(t, e) {
  var r = t[Y];
  return (r ? O(r) : t)[e];
}
function K(t, e) {
  if (e in t) for (var r = Object.getPrototypeOf(t); r;) {
    var n = Object.getOwnPropertyDescriptor(r, e);
    if (n) return n;
    r = Object.getPrototypeOf(r);
  }
}
function T(t) {
  t.P || (t.P = !0, t.l && T(t.l));
}
function V(t) {
  t.o || (t.o = S(t.t));
}
function C(t, e, r) {
  var n = g(e) ? D("MapSet").N(e, r) : P(e) ? D("MapSet").T(e, r) : t.g ? function (t, e) {
    var r = Array.isArray(t),
      n = {
        i: r ? 1 : 0,
        A: e ? e.A : $(),
        P: !1,
        I: !1,
        D: {},
        l: e,
        t: t,
        k: null,
        o: null,
        j: null,
        C: !1
      },
      o = n,
      i = ot;
    r && (o = [n], i = it);
    var a = Proxy.revocable(o, i),
      u = a.revoke,
      c = a.proxy;
    return n.k = c, n.j = u, c;
  }(e, r) : D("ES5").J(e, r);
  return (r ? r.A : $()).p.push(n), n;
}
function U(t) {
  return d(t) || p(22, t), function t(e) {
    if (!b(e)) return e;
    var r,
      n = e[Y],
      o = y(e);
    if (n) {
      if (!n.P && (n.i < 4 || !D("ES5").K(n))) return n.t;
      n.I = !0, r = W(e, o), n.I = !1;
    } else r = W(e, o);
    return h(r, function (e, o) {
      n && function (t, e) {
        return 2 === y(t) ? t.get(e) : t[e];
      }(n.t, e) === o || m(r, e, t(o));
    }), 3 === o ? new Set(r) : r;
  }(t);
}
function W(t, e) {
  switch (e) {
    case 2:
      return new Map(t);
    case 3:
      return Array.from(t);
  }
  return S(t);
}
var J,
  G,
  L = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"),
  X = "undefined" != typeof Map,
  q = "undefined" != typeof Set,
  B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect,
  H = L ? Symbol.for("immer-nothing") : ((J = {})["immer-nothing"] = !0, J),
  Q = L ? Symbol.for("immer-draftable") : "__$immer_draftable",
  Y = L ? Symbol.for("immer-state") : "__$immer_state",
  tt = "" + Object.prototype.constructor,
  et = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function (t) {
    return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
  } : Object.getOwnPropertyNames,
  rt = Object.getOwnPropertyDescriptors || function (t) {
    var e = {};
    return et(t).forEach(function (r) {
      e[r] = Object.getOwnPropertyDescriptor(t, r);
    }), e;
  },
  nt = {},
  ot = {
    get: function (t, e) {
      if (e === Y) return t;
      var r = O(t);
      if (!v(r, e)) return function (t, e, r) {
        var n,
          o = K(e, r);
        return o ? "value" in o ? o.value : null === (n = o.get) || void 0 === n ? void 0 : n.call(t.k) : void 0;
      }(t, r, e);
      var n = r[e];
      return t.I || !b(n) ? n : n === R(t.t, e) ? (V(t), t.o[e] = C(t.A.h, n, t)) : n;
    },
    has: function (t, e) {
      return e in O(t);
    },
    ownKeys: function (t) {
      return Reflect.ownKeys(O(t));
    },
    set: function (t, e, r) {
      var n = K(O(t), e);
      if (null == n ? void 0 : n.set) return n.set.call(t.k, r), !0;
      if (!t.P) {
        var o = R(O(t), e),
          i = null == o ? void 0 : o[Y];
        if (i && i.t === r) return t.o[e] = r, t.D[e] = !1, !0;
        if (function (t, e) {
          return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e;
        }(r, o) && (void 0 !== r || v(t.t, e))) return !0;
        V(t), T(t);
      }
      return t.o[e] === r && "number" != typeof r && (void 0 !== r || e in t.o) || (t.o[e] = r, t.D[e] = !0, !0);
    },
    deleteProperty: function (t, e) {
      return void 0 !== R(t.t, e) || e in t.t ? (t.D[e] = !1, V(t), T(t)) : delete t.D[e], t.o && delete t.o[e], !0;
    },
    getOwnPropertyDescriptor: function (t, e) {
      var r = O(t),
        n = Reflect.getOwnPropertyDescriptor(r, e);
      return n ? {
        writable: !0,
        configurable: 1 !== t.i || "length" !== e,
        enumerable: n.enumerable,
        value: r[e]
      } : n;
    },
    defineProperty: function () {
      p(11);
    },
    getPrototypeOf: function (t) {
      return Object.getPrototypeOf(t.t);
    },
    setPrototypeOf: function () {
      p(12);
    }
  },
  it = {};
h(ot, function (t, e) {
  it[t] = function () {
    return arguments[0] = arguments[0][0], e.apply(this, arguments);
  };
}), it.deleteProperty = function (t, e) {
  return it.set.call(this, t, e, void 0);
}, it.set = function (t, e, r) {
  return ot.set.call(this, t[0], e, r, t[0]);
};
var at = function () {
    function t(t) {
      var e = this;
      this.g = B, this.F = !0, this.produce = function (t, r, n) {
        if ("function" == typeof t && "function" != typeof r) {
          var o = r;
          r = t;
          var i = e;
          return function (t) {
            var e = this;
            void 0 === t && (t = o);
            for (var n = arguments.length, a = Array(n > 1 ? n - 1 : 0), u = 1; u < n; u++) a[u - 1] = arguments[u];
            return i.produce(t, function (t) {
              var n;
              return (n = r).call.apply(n, [e, t].concat(a));
            });
          };
        }
        var a;
        if ("function" != typeof r && p(6), void 0 !== n && "function" != typeof n && p(7), b(t)) {
          var u = I(e),
            c = C(e, t, void 0),
            s = !0;
          try {
            a = r(c), s = !1;
          } finally {
            s ? x(u) : _(u);
          }
          return "undefined" != typeof Promise && a instanceof Promise ? a.then(function (t) {
            return A(u, n), k(t, u);
          }, function (t) {
            throw x(u), t;
          }) : (A(u, n), k(a, u));
        }
        if (!t || "object" != typeof t) {
          if (void 0 === (a = r(t)) && (a = t), a === H && (a = void 0), e.F && w(a, !0), n) {
            var f = [],
              l = [];
            D("Patches").M(t, a, f, l), n(f, l);
          }
          return a;
        }
        p(21, t);
      }, this.produceWithPatches = function (t, r) {
        if ("function" == typeof t) return function (r) {
          for (var n = arguments.length, o = Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) o[i - 1] = arguments[i];
          return e.produceWithPatches(r, function (e) {
            return t.apply(void 0, [e].concat(o));
          });
        };
        var n,
          o,
          i = e.produce(t, r, function (t, e) {
            n = t, o = e;
          });
        return "undefined" != typeof Promise && i instanceof Promise ? i.then(function (t) {
          return [t, n, o];
        }) : [i, n, o];
      }, "boolean" == typeof (null == t ? void 0 : t.useProxies) && this.setUseProxies(t.useProxies), "boolean" == typeof (null == t ? void 0 : t.autoFreeze) && this.setAutoFreeze(t.autoFreeze);
    }
    var e = t.prototype;
    return e.createDraft = function (t) {
      b(t) || p(8), d(t) && (t = U(t));
      var e = I(this),
        r = C(this, t, void 0);
      return r[Y].C = !0, _(e), r;
    }, e.finishDraft = function (t, e) {
      var r = t && t[Y];
      var n = r.A;
      return A(n, e), k(void 0, n);
    }, e.setAutoFreeze = function (t) {
      this.F = t;
    }, e.setUseProxies = function (t) {
      t && !B && p(20), this.g = t;
    }, e.applyPatches = function (t, e) {
      var r;
      for (r = e.length - 1; r >= 0; r--) {
        var n = e[r];
        if (0 === n.path.length && "replace" === n.op) {
          t = n.value;
          break;
        }
      }
      r > -1 && (e = e.slice(r + 1));
      var o = D("Patches").$;
      return d(t) ? o(t, e) : this.produce(t, function (t) {
        return o(t, e);
      });
    }, t;
  }(),
  ut = new at(),
  ct = ut.produce;
ut.produceWithPatches.bind(ut);
var st = ut.setAutoFreeze.bind(ut);
ut.setUseProxies.bind(ut), ut.applyPatches.bind(ut), ut.createDraft.bind(ut), ut.finishDraft.bind(ut);
const ft = t => t,
  lt = Symbol("subscribe"),
  pt = t => {
    const e = t === null || t === void 0 ? void 0 : t[lt];
    return e || t;
  };
st(!1);
const dt = function (t, e) {
    let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return new Proxy(t, {
      get: (n, i) => i === lt ? (e(r), t) : t[i] && a(t[i]) ? dt(t[i], e, "".concat(r).concat(o(n) ? "[".concat(i, "]") : "".concat(r ? "." : "").concat(i))) : (e("".concat(r).concat(o(n) ? "[".concat(i, "]") : "".concat(r ? "." : "").concat(i))), t[i])
    });
  },
  bt = function (t, e, r) {
    let n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    let u = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
    if (o(t) && o(e)) return e.forEach((o, a) => {
      if (n.push("".concat(u, "[").concat(a, "]")), i(t[a])) t[a] = o;else {
        if (e[a]) return bt(t[a], e[a], r, n, "".concat(u, "[").concat(a, "]"));
        t[a] = e[a];
      }
    }), t.length = e.length, n;
    if (a(e)) {
      for (let o in e) if (o in t) {
        if (a(e[o]) && e[o] && (r.fireDuplicates || t[o] !== e[o])) {
          if (n.push("".concat(u).concat(u ? "." : "").concat(o)), e[o] && t[o]) return bt(t[o], e[o], r, n, "".concat(u).concat(u ? "." : "").concat(o));
          t[o] = e[o];
        } else (r.fireDuplicates || t[o] !== e[o]) && (t[o] = e[o], n.push("".concat(u).concat(u ? "." : "").concat(o)));
      } else n.push("".concat(u).concat(u ? "." : "").concat(o)), t[o] = e[o];
      return n;
    }
    return (r.fireDuplicates || t !== e) && (t = e), n;
  };
createModel = eventStorm.createModel = (t, e) => {
  const r = String(l++),
    n = s(r, t, e);
  return {
    getState: () => n.lastState,
    dispatch: (t, e) => {
      f(r, t, {
        ...e
      });
    },
    setOptions: t => ((t, e) => {
      c(t).options = e;
    })(r, t),
    subscribe: (t, e) => function (t, e) {
      let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      const n = c(t);
      return r.needPrevious && e(n.lastState), !n.subscribers.some(t => t.callback === e) && n.subscribers.push({
        callback: e
      }), () => {
        n.subscribers = n.subscribers.filter(t => t.callback !== e);
      };
    }(r, t, e)
  };
}, eventStorm.createStorm = (t, e) => {
  let r = t,
    o = {},
    a = [];
  return {
    getState: () => r,
    subscribe: t => {
      let e = new Set();
      const n = dt(r, t => {
        t && e.add(t);
      });
      return t(n, pt), !e.size && e.add("default", t), e.forEach(e => {
        o[e] = o[e] || [], o[e].push(t);
      }), () => {
        e.forEach(e => {
          o[e] = o[e].filter(e => e !== t);
        });
      };
    },
    addMiddleware: t => (a.push(t), () => {
      a = a.filter(e => e !== t);
    }),
    dispatch: (t, u) => {
      var _o$default;
      let c;
      const s = n(t) ? t(r) : t,
        f = ct(r, t => {
          c = bt(t, s, {
            ...e,
            ...(u || {})
          });
        }),
        l = [f, r];
      !i(u) && l.push(u), a.forEach(t => t(...l)), r = f, c.forEach(t => {
        o[t] && o[t].forEach(t => {
          t(r, ft);
        });
      }), (_o$default = o.default) === null || _o$default === void 0 ? void 0 : _o$default.forEach(t => t(r, ft));
    }
  };
}, createVirtualModel = eventStorm.createVirtualModel = function () {
  let {
    models: r = [],
    handler: n,
    ...o
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const i = e({
    options: o
  });
  i.options.handler = n, i.options.models = r;
  const a = () => i.options.models.map(t => t.getState()),
    u = t => {
      const e = i.options.handler(...a()),
        {
          lastState: r
        } = i;
      i.lastState = e, i.subscribers.forEach(_ref4 => {
        let {
          callback: n
        } = _ref4;
        return i.options.fireDuplicates || e !== r ? n(e, t) : void 0;
      });
    };
  let c = r.map(t => t.subscribe((t, e) => u(e))),
    s = !1;
  return {
    getState: () => ((s || i.lastState === t) && (i.lastState = i.options.handler(...a())), i.lastState),
    subscribe: function (t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return e.needPrevious && t(this.getState()), !i.subscribers.some(e => e.callback === t) && i.subscribers.push({
        callback: t
      }), () => {
        i.subscribers = i.subscribers.filter(e => e.callback !== t);
      };
    },
    setOptions: _ref5 => {
      let {
        models: t,
        handler: e = i.options.handler,
        ...r
      } = _ref5;
      i.options = {
        ...i.options,
        ...r,
        handler: e
      }, t && (c.map(t => t()), i.options.models = t, c = t.map(t => t.subscribe((t, e) => u(e))), s = !0), i.options.models.forEach(t => {
        t.setOptions(r);
      });
    }
  };
}, eventStorm.persisted = t => _ref6 => {
  let {
    storageKey: e,
    beforeunload: n = r,
    permanent: o = !1
  } = _ref6;
  return r => {
    let i;
    try {
      const t = o ? window.localStorage : window.sessionStorage;
      i = JSON.parse(t.getItem(e));
    } catch {
      i = {};
    }
    const a = t({
      ...r,
      ...i
    });
    return window.addEventListener("beforeunload", () => {
      try {
        (o ? window.localStorage : window.sessionStorage).setItem(e, JSON.stringify(n(a.getState())));
      } catch {}
    }), a;
  };
};

const DEFAULT_PRIVATE_API_VERSION = 'v4';

let InternalExtensionStatus = /*#__PURE__*/function (InternalExtensionStatus) {
  InternalExtensionStatus["opened"] = "opened";
  InternalExtensionStatus["notReady"] = "not-ready";
  return InternalExtensionStatus;
}({});

class InternalContext {
  constructor() {
    this.listeners = {};
    this.listenersQueue = {};
    this.status = InternalExtensionStatus.notReady;
    this.extensionType = null;
    this.sid = null;
    this.miniapp = null;
    this.apiHeaders = {};
    this.ui = createModel();
    this.hostName = '';
    this.toolPrices = null;
    this.bootstrapCame = false;
    this.authModel = createModel();
    this.platformLayerIds = new Set();
    this.privateAPIVersion = DEFAULT_PRIVATE_API_VERSION;
    this.isOpened = () => this.status !== InternalExtensionStatus.opened;
    this.setExtensionType = nextType => this.extensionType = nextType;
    this.updateExtensionStatus = nextStatus => this.status = nextStatus;
  }
  update(key, value) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this[key] = value;
    if (this.listeners[key]) {
      this.listeners[key].forEach(cb => {
        this.listenersQueue[key] = () => cb(this[key]);
      });
    }
  }
  redraw() {
    Object.values(this.listenersQueue).forEach(cb => cb());
    this.listenersQueue = {};
  }
  onUpdate(key, cb) {
    if (!this.listeners[key]) {
      this.listeners[key] = [];
    }
    this.listeners[key].push(cb);
    return () => {
      this.listeners[key] = this.listeners[key].filter(item => item !== cb);
    };
  }
}
const internalContext = new InternalContext();

const PRODUCTION_DOMAIN = 'picsart.com';
const MOBILES_LOCALHOST_DOMAIN = 'picsart-miniapp-local';
const ENV_PARAM = 'pa_env';
function getCDNUrl() {
  let hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  // Normally client sdk knows if it is prod or stage by looking on the hostname
  let useProdCDN = hostname.includes(PRODUCTION_DOMAIN);

  // But we have corner case: when miniapp prefectched and cached locally on the native platforms
  // it's url is something like picsart-local://picsart-miniapp-local
  // And prev check will return stage migrations for prod miniapps
  // on mobile we can't change hostnames for prefetched miniapps because of white listing
  // and stage and prod have same hostname.
  // But we can pass query param to force stage migrations
  if (hostname.includes(MOBILES_LOCALHOST_DOMAIN)) {
    const searchParams = new URLSearchParams(search);
    useProdCDN = searchParams.has(ENV_PARAM) && searchParams.get(ENV_PARAM) === 'stage' ? false : true;
  }
  const result = "https://extensions-cdn.".concat(useProdCDN ? 'picsart' : 'picsartstage2', ".com/migrations.js?version=alpha");
  return result;
}

const CDN_URL = getCDNUrl(window.location.hostname, window.location.search);
const SDK_VERSION = 'v8';
const runMigrations = async (data, send) => {
  // Check version mismatch upfront
  if (internalContext.privateAPIVersion === SDK_VERSION) {
    // If versions match, or no migration logic is required, resolve with the original data
    return data;
  }

  // Migration loaded, just execute them
  if (window.runPrivateAPIMigrations) {
    return window.runPrivateAPIMigrations(data, {
      send,
      platformVersion: internalContext.privateAPIVersion,
      sdkVersion: SDK_VERSION
    });
  }

  // Development mode - it should NEVER be commited with isDev = true
  {
    // Load remote script
    return new Promise(resolve => {
      const script = document.createElement('script');
      script.onload = () => {
        // Once the script is loaded, apply the migrations
        resolve(window.runPrivateAPIMigrations(data, {
          send,
          platformVersion: internalContext.privateAPIVersion,
          sdkVersion: SDK_VERSION
        }));
      };
      script.onerror = () => {
        // Handle script loading error
        console.error('Failed to load migration script');
        resolve(data);
      };
      document.body.append(script);
      script.src = CDN_URL;
    });
  }
};

const DISPATCH_SHARED_STORAGE_CONFIG_KEY = 'DISPATCH_SHARED_STORAGE_CONFIG_KEY';
const DISPATCH_SHARED_STORAGE_SID_KEY = 'DISPATCH_SHARED_STORAGE_SID_KEY';
const DISPATCH_SHARED_STORAGE_CONFIGS = {
  [DISPATCH_SHARED_STORAGE_CONFIG_KEY]: true
};
const searchParams$1 = new URLSearchParams(window.location.search);
const platformQuery = searchParams$1.get('platform');

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop$1 = () => {};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

const channel = new MessageChannel();
let nativeJsPortTwo = channel.port2;
const nativeJsPortOne = channel.port1;
const androidResolver = {
  current: noop$1
};
const androidResolvePromise = new Promise(resolve => {
  androidResolver.current = resolve;
});
window.addEventListener('message', event => {
  if (event.data === 'capturePort') {
    if (event.ports[0] !== null) {
      nativeJsPortTwo = event.ports[0];
      androidResolver.current();
    }
  } else {
    try {
      typeof event.data === 'string' && nativeJsPortOne.postMessage(JSON.parse(event.data));
    } catch (err) {
      console.log(err);
    }
  }
});
const addListener = handler => {
  nativeJsPortTwo.addEventListener('message', handler);
  return () => nativeJsPortTwo.removeEventListener('message', handler);
};
nativeJsPortOne.start();
nativeJsPortTwo.start();
const normalizedUserAgent = window.navigator.userAgent.toLowerCase();
const isAndroidDevice = /android/.test(normalizedUserAgent);
const isAndroid = () => isAndroidDevice && /; wv\)/.test(normalizedUserAgent);
const isWindows = () => {
  var _window;
  return !!((_window = window) !== null && _window !== void 0 && (_window = _window.chrome) !== null && _window !== void 0 && _window.webview);
};
const isIOS = () => {
  var _window$webkit;
  return !!((_window$webkit = window['webkit']) !== null && _window$webkit !== void 0 && _window$webkit.messageHandlers.bridge);
};
const isAndroidProtocol = () => platformQuery === 'android' || isAndroid();
const isWindowsProtocol = () => platformQuery === 'windows' || isWindows();
const isIOSProtocol = () => platformQuery === 'ios' || isIOS();
const sendToWeb = data => window.parent.postMessage(data, '*');
const sendToAndroid = async data => {
  await androidResolvePromise;
  nativeJsPortTwo.postMessage(data);
};
const sendToWindows = data => window.chrome.webview.postMessage(data);
const sendToIos = data => window['webkit'].messageHandlers.bridge.postMessage(data);

let ReceiveMessages = /*#__PURE__*/function (ReceiveMessages) {
  ReceiveMessages["close"] = "close";
  ReceiveMessages["bootstrap"] = "bootstrap";
  ReceiveMessages["deactivate"] = "deactivate";
  ReceiveMessages["customEvent"] = "custom-event";
  ReceiveMessages["redirectResponse"] = "redirect-res";
  ReceiveMessages["syncContext"] = "sync-context";
  ReceiveMessages["resolveMessage"] = "resolve-message";
  ReceiveMessages["openFileChooserResponse"] = "chooser-res";
  ReceiveMessages["refreshTokenResponse"] = "refresh-token-res";
  ReceiveMessages["remoteSettingsResponse"] = "remote-settings-res";
  ReceiveMessages["fetchAlbumsResponse"] = "fetch-media-albums-res";
  ReceiveMessages["requestPermissionResponse"] = "request-permission-res";
  ReceiveMessages["fetchMediaAssetsResponse"] = "fetch-media-assets-res";
  ReceiveMessages["generateResultImageResponse"] = "generate-result-image-res";
  ReceiveMessages["syncRequest"] = "sync-request";
  return ReceiveMessages;
}({});
let SendMessages = /*#__PURE__*/function (SendMessages) {
  SendMessages["error"] = "error";
  SendMessages["share"] = "share";
  SendMessages["ready"] = "ready";
  SendMessages["close"] = "close-res";
  SendMessages["notifier"] = "notifier";
  SendMessages["dialog"] = "dialog";
  SendMessages["redirect"] = "redirect";
  SendMessages["navigate"] = "navigate";
  SendMessages["analytics"] = "analytics";
  SendMessages["download"] = "download";
  SendMessages["downloadFile"] = "export";
  SendMessages["saveState"] = "save-state";
  SendMessages["openFileChooser"] = "chooser";
  SendMessages["configureUi"] = "configure-ui";
  SendMessages["syncContext"] = "sync-context";
  SendMessages["refreshToken"] = "refresh-token";
  SendMessages["customEvent"] = "custom-event-res";
  SendMessages["fetchAlbums"] = "fetch-media-albums";
  SendMessages["requestPermission"] = "request-permission";
  SendMessages["getRemoteSettings"] = "remote-settings";
  SendMessages["fetchMediaAssets"] = "fetch-media-assets";
  SendMessages["redirectToPackageId"] = "redirect-to-package-id";
  SendMessages["generateResultImage"] = "generate-result-image";
  SendMessages["resolveMessage"] = "resolve-message";
  return SendMessages;
}({});

const isServerSupported = () => isIOS() || isAndroid() || isWindows();
const isWeb = () => !isAndroid() && !isIOS() && !isWindows();
const isWebProtocol = () => platformQuery === 'web' || isWeb();

const sendData$1 = async jsonString => {
  if (isWebProtocol()) return sendToWeb(jsonString);
  if (isIOSProtocol()) return sendToIos(jsonString);
  if (isWindowsProtocol()) return sendToWindows(jsonString);
  if (isAndroidProtocol()) return sendToAndroid(jsonString);
  return sendToWeb(jsonString);
};

const sendData = async data => {
  // NOTE: Migrate the data to be sent to the platform API version.
  const migratedData = await runMigrations(data, true);
  const jsonString = JSON.stringify({
    ...migratedData,
    sid: internalContext.sid
  });
  return sendData$1(jsonString);
};

const eventListeners = new Map();
const onEvent = eventName => cb => {
  var _eventListeners$get;
  if (!eventListeners.has(eventName)) {
    eventListeners.set(eventName, new Set());
  }
  (_eventListeners$get = eventListeners.get(eventName)) === null || _eventListeners$get === void 0 || _eventListeners$get.add(cb);
  return () => {
    var _eventListeners$get2;
    (_eventListeners$get2 = eventListeners.get(eventName)) === null || _eventListeners$get2 === void 0 || _eventListeners$get2.delete(cb);
  };
};
const callListeners = (eventName, payload) => {
  const promises = [...(eventListeners.get(eventName) || [])].map(cb => cb(payload));
  return Promise.all(promises);
};
const onBootstrap = onEvent(ReceiveMessages.bootstrap);
const onResolveMessage = onEvent(ReceiveMessages.resolveMessage);
const onOpenFileChooserResponse = onEvent(ReceiveMessages.openFileChooserResponse);
const onAuthRedirectResponse = onEvent(ReceiveMessages.redirectResponse);
const onClose = onEvent(ReceiveMessages.close);
const onRemoteSettings = onEvent(ReceiveMessages.remoteSettingsResponse);
const onContextChange = onEvent(ReceiveMessages.syncContext);
const onCustomEvent = onEvent(ReceiveMessages.customEvent);
const onDeactivate = onEvent(ReceiveMessages.deactivate);
const onRefreshTokenResponse = onEvent(ReceiveMessages.refreshTokenResponse);
const onGeneratedResultImage = onEvent(ReceiveMessages.generateResultImageResponse);
const onFetchAlbums = onEvent(ReceiveMessages.fetchAlbumsResponse);
const onFetchMediaAssets = onEvent(ReceiveMessages.fetchMediaAssetsResponse);
const onSyncRequest = onEvent(ReceiveMessages.syncRequest);
const onRequestPermission = onEvent(ReceiveMessages.requestPermissionResponse);

// NOTE: window assignments below, are for native platforms
window.messageJSONHandler = async data => window.messageHandler({
  data: await runMigrations(JSON.parse(data), false)
});
window.messageHandler = async _ref => {
  let {
    data
  } = _ref;
  const {
    action,
    payload,
    resolveId
  } = data;
  try {
    const result = await callListeners(action, payload);
    sendData({
      action: SendMessages.resolveMessage,
      resolveId,
      payload: {
        success: true,
        result
      }
    });
  } catch (error) {
    sendData({
      action: SendMessages.resolveMessage,
      resolveId,
      payload: {
        success: false,
        error: error.message
      }
    });
  }
};
addListener(async _ref2 => {
  let {
    data
  } = _ref2;
  const migratedData = await runMigrations(data, false);
  Object.values(ReceiveMessages).includes(data.action) && window.messageHandler({
    data: migratedData
  });
});

const resolvify = data => {
  const resolveId = createResolveSid();
  return new Promise(resolve => {
    sendData({
      ...data,
      resolveId
    });
    sidMap.set(resolveId, resolve);
  });
};

const sendAnalytics = async payload => {
  return resolvify({
    action: SendMessages.analytics,
    payload: {
      params: {},
      ...payload
    }
  });
};
const save = async payload => {
  return resolvify({
    action: SendMessages.saveState,
    payload
  });
};
const raiseError = async payload => {
  return resolvify({
    action: SendMessages.error,
    payload
  });
};
const syncContext = async payload => {
  return resolvify({
    action: SendMessages.syncContext,
    payload
  });
};
const redirect = async payload => {
  return resolvify({
    action: SendMessages.redirect,
    payload
  });
};
const navigate$1 = async payload => {
  return resolvify({
    action: SendMessages.navigate,
    payload
  });
};
const close = async function () {
  let payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return resolvify({
    action: SendMessages.close,
    payload
  });
};
const sendRemoteSettingsRequest = payload => {
  return resolvify({
    action: SendMessages.getRemoteSettings,
    payload
  });
};
const sendNotifierMessage = async payload => {
  return resolvify({
    action: SendMessages.notifier,
    payload
  });
};
const configureUI = async payload => {
  return resolvify({
    action: SendMessages.configureUi,
    payload
  });
};
const sendDialogMessage = async payload => {
  return resolvify({
    action: SendMessages.dialog,
    payload
  });
};
const ready = async function () {
  let payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return resolvify({
    action: SendMessages.ready,
    payload
  });
};
const openFileChooser = async payload => {
  return resolvify({
    action: SendMessages.openFileChooser,
    payload
  });
};
const exportFiles = async payload => {
  return resolvify({
    action: SendMessages.downloadFile,
    payload
  });
};
const download$1 = async payload => {
  return resolvify({
    action: SendMessages.download,
    payload
  });
};
const publishEvent$1 = async payload => {
  return resolvify({
    action: SendMessages.customEvent,
    payload
  });
};
const redirectToPackageId = async function (packageId) {
  let {
    comeback = false,
    modal = false,
    ...rest
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return resolvify({
    action: SendMessages.redirectToPackageId,
    payload: {
      packageId,
      comeback,
      modal,
      ...rest
    }
  });
};
const share = async payload => {
  return resolvify({
    action: SendMessages.share,
    payload
  });
};
const generateResultImage$1 = async payload => {
  return resolvify({
    action: SendMessages.generateResultImage,
    payload
  });
};
const sendRefreshToken = async function () {
  let payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return resolvify({
    action: SendMessages.refreshToken,
    payload
  });
};
const fetchAlbums$1 = async payload => {
  return resolvify({
    action: SendMessages.fetchAlbums,
    payload
  });
};
const requestPermission$1 = async (sid, permissionType, requestIfRejected) => {
  return resolvify({
    action: SendMessages.requestPermission,
    payload: {
      sid: sid,
      permissionType: permissionType,
      requestIfRejected: requestIfRejected
    }
  });
};
const fetchMediaAssets$1 = async payload => {
  return resolvify({
    action: SendMessages.fetchMediaAssets,
    payload
  });
};

let refreshTokenUpdateHasError = false;
const fetchWrapper = async function (url) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const response = await fetch(url, {
    ...options,
    headers: {
      ...((options === null || options === void 0 ? void 0 : options.headers) || {}),
      ...internalContext.apiHeaders
    }
  });
  const requestUrl = url;
  const asURL = new URL(requestUrl);
  const isPicsartUrl = asURL.hostname.includes('picsart');
  if (response.status === 401 && isPicsartUrl) {
    if (refreshTokenUpdateHasError) return response;
    const promise = new Promise((resolve, reject) => {
      onRefreshTokenResponse(_ref => {
        let {
          headers,
          error
        } = _ref;
        if (error) reject();
        internalContext.apiHeaders = {
          ...internalContext.apiHeaders,
          ...headers
        };
        resolve();
      });
    });
    sendRefreshToken();
    try {
      await promise;
    } catch (err) {
      refreshTokenUpdateHasError = true;
    }
    return fetch(url, {
      ...options,
      headers: {
        ...((options === null || options === void 0 ? void 0 : options.headers) || {}),
        ...internalContext.apiHeaders
      }
    });
  }
  return response;
};

function createUtilsContext(context) {
  return Object.assign(context, {
    utils: {
      api: {
        getHeaders: () => internalContext.apiHeaders,
        fetch: fetchWrapper
      },
      signatures: {
        newLayer: settings => {
          var _internalContext$mini, _internalContext$mini2;
          return {
            created_by_tool: JSON.stringify({
              package_id: (_internalContext$mini = internalContext.miniapp) === null || _internalContext$mini === void 0 ? void 0 : _internalContext$mini.packageId,
              version: (_internalContext$mini2 = internalContext.miniapp) === null || _internalContext$mini2 === void 0 ? void 0 : _internalContext$mini2.appVersion,
              settings
            })
          };
        }
      }
    }
  });
}

function createLayoutContext(context) {
  return Object.assign(context, {
    layout: {
      loading: loading => configureUI({
        loading
      }),
      notification: {
        show: async options => {
          const response = await sendNotifierMessage({
            type: 'notification',
            params: {
              title: options.title,
              icon: options.icon,
              description: options.description,
              type: options.type
            }
          });
          const {
            reason
          } = response.result || {};
          if (reason === 'close') {
            var _options$onClose;
            (_options$onClose = options.onClose) === null || _options$onClose === void 0 || _options$onClose.call(options);
            return;
          }
          if (reason === 'action') {
            var _onIconClick, _ref;
            (_onIconClick = (_ref = options).onIconClick) === null || _onIconClick === void 0 || _onIconClick.call(_ref);
            return;
          }
        }
      },
      snackbar: {
        show: async options => {
          const response = await sendNotifierMessage({
            type: 'snackbar',
            params: {
              title: options.title,
              icon: options.icon,
              type: options.type
            }
          });
          const {
            reason
          } = response.result || {};
          if (reason === 'close') {
            var _options$onClose2;
            (_options$onClose2 = options.onClose) === null || _options$onClose2 === void 0 || _options$onClose2.call(options);
            return;
          }
          if (reason === 'action') {
            var _onIconClick2, _ref2;
            (_onIconClick2 = (_ref2 = options).onIconClick) === null || _onIconClick2 === void 0 || _onIconClick2.call(_ref2);
            return;
          }
        }
      },
      dialog: {
        show: async options => {
          const response = await sendDialogMessage(options);
          const {
            result
          } = response.result || {};
          if (result === 'dismissed') {
            var _options$onDismiss;
            (_options$onDismiss = options.onDismiss) === null || _options$onDismiss === void 0 || _options$onDismiss.call(options);
            return;
          }
          if (result === 'primary') {
            options.primaryAction();
            return;
          }
          if (result === 'secondary') {
            var _options$secondaryAct;
            (_options$secondaryAct = options.secondaryAction) === null || _options$secondaryAct === void 0 || _options$secondaryAct.call(options);
            return;
          }
        }
      }
    }
  });
}

/*
  The handler is first step to unify navigating between platforms
  Before miniapp developers have to use different methods for each platform
  and write if branching in their code
  In the bright future when we have all links unified it will be just a call
  to navigate('http://picsart.com/edit') what will work cross platform
*/
const navigate = (web, ios, android) => {
  if (!web && !ios && !android) {
    throw new Error('No destination provided');
  }
  if (isWeb()) {
    if (!web) {
      throw new Error('No web destination provided');
    }
    navigate$1({
      url: web
    });
    window.location.href = web;
  } else if (isIOS()) {
    if (!ios) {
      throw new Error('No iOS destination provided');
    }
    navigate$1({
      url: ios
    });
  } else if (isAndroid()) {
    if (!android) {
      throw new Error('No Android destination provided');
    }
    navigate$1({
      url: android
    });
  }
};

const getExtension = mimeType => mimeType.split('/')[1];

// NOTE:: here we are scheduling the out-coming requests, cause there is a limit of browser open tcp count
// and all the parallel requests coming here must be put into schedule per threshold(maybe configured per browser).
// The scheduler will try to pick more requests as far as the cycle provides any resolved promise
const tcpLimit = 6;
const scheduledQueue = [];
const activeQueue = [];
const schedulerCheck = () => {
  if (activeQueue.length <= tcpLimit && scheduledQueue.length) {
    const next = scheduledQueue.shift();
    if (next) {
      const promise = next();
      activeQueue.push(promise);
      promise.then(() => {
        activeQueue.splice(activeQueue.indexOf(promise), 1);
        schedulerCheck();
      });
    }
  }
};
const withScheduler = executor => {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return new Promise((resolve, reject) => {
      scheduledQueue.push(async () => {
        try {
          const result = await executor(...args);
          resolve(result);
        } catch (err) {
          reject(err);
        }
      });
      schedulerCheck();
    });
  };
};

const baseUrl = 'https://localhost:4000';
const fileQuery = 'file';

const setImage = async (filename, file) => {
  const formData = new FormData();
  formData.append('image', file, filename);
  const response = await fetch("".concat(baseUrl, "/storage"), {
    method: 'POST',
    body: formData
  });
  return response.ok;
};
var setImage$1 = withScheduler(setImage);

const uploadBlob = async blob => {
  const filename = "".concat(generateId(), ".").concat(getExtension(blob.type));
  await setImage$1(filename, blob);
  return filename;
};

/**
 * Uploads a url to the mobile local server and returns the final url to send to the host.
 * This is used together with @function useLocalServer to upload base64 or blob urls to mobile as local files, so then mobile can handle those resources as files instead of base64 or blob url.
 * If the url doesn't have a protocol, this means @param resourceUrl it's a file name that was passed by mobile to reference a local file and then it doesn't need to be uploaded, it would be a redundant file., and the same resource url is returned.
 *
 * @param resourceUrl
 * @returns Promise with upload url or @param resourceUrl if it can't be uploaded
 */
const uploadToLocalServer = resourceUrl => {
  if (!hasProtocol(resourceUrl)) return Promise.resolve(resourceUrl);
  return new Promise(async (res, rej) => {
    const response = await fetch(resourceUrl);
    const blob = await response.blob();
    uploadBlob(blob).then(res).catch(rej);
  });
};
const hasProtocol = url => url.includes(':');

const receiveProtocols = ['http://', 'https://'];
const sendProtocols = ['http://', 'https://', 'blob:', 'data:'];
const useLocalServer = (url, from) => (from ? receiveProtocols : sendProtocols).every(protocol => !url.startsWith(protocol)) && isServerSupported();

const download = async options => {
  const transformedOptions = await Promise.all(options.map(async option => {
    if (useLocalServer(option.url, true)) {
      return {
        ...option,
        url: await uploadToLocalServer(option.url)
      };
    }
    return option;
  }));
  return download$1({
    files: transformedOptions
  });
};

const publishEvent = async data => {
  const sid = createPublishEventSid();
  await publishEvent$1({
    data: JSON.stringify(data),
    sid
  });
  return new Promise(resolve => sidMap.set(sid, resolve));
};

// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
function die(error) {
  throw new Error("[Immer] minified error nr: ".concat(error, ". Full error at: https://bit.ly/3cXEKWf"));
}

// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
  return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
  var _value$constructor;
  if (!value) return false;
  return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_value$constructor = value.constructor) !== null && _value$constructor !== void 0 && _value$constructor[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
  if (!value || typeof value !== "object") return false;
  const proto = getPrototypeOf(value);
  if (proto === null) {
    return true;
  }
  const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
  if (Ctor === Object) return true;
  return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function each(obj, iter) {
  if (getArchtype(obj) === 0 /* Object */) {
    Object.entries(obj).forEach(_ref8 => {
      let [key, value] = _ref8;
      iter(key, value, obj);
    });
  } else {
    obj.forEach((entry, index) => iter(index, entry, obj));
  }
}
function getArchtype(thing) {
  const state = thing[DRAFT_STATE];
  return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */ : isMap(thing) ? 2 /* Map */ : isSet(thing) ? 3 /* Set */ : 0 /* Object */;
}
function has(thing, prop) {
  return getArchtype(thing) === 2 /* Map */ ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function set(thing, propOrOldValue, value) {
  const t = getArchtype(thing);
  if (t === 2 /* Map */) thing.set(propOrOldValue, value);else if (t === 3 /* Set */) {
    thing.add(value);
  } else thing[propOrOldValue] = value;
}
function is(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function isMap(target) {
  return target instanceof Map;
}
function isSet(target) {
  return target instanceof Set;
}
function latest(state) {
  return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
  if (isMap(base)) {
    return new Map(base);
  }
  if (isSet(base)) {
    return new Set(base);
  }
  if (Array.isArray(base)) return Array.prototype.slice.call(base);
  if (!strict && isPlainObject(base)) {
    if (!getPrototypeOf(base)) {
      const obj = /* @__PURE__ */Object.create(null);
      return Object.assign(obj, base);
    }
    return {
      ...base
    };
  }
  const descriptors = Object.getOwnPropertyDescriptors(base);
  delete descriptors[DRAFT_STATE];
  let keys = Reflect.ownKeys(descriptors);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const desc = descriptors[key];
    if (desc.writable === false) {
      desc.writable = true;
      desc.configurable = true;
    }
    if (desc.get || desc.set) descriptors[key] = {
      configurable: true,
      writable: true,
      // could live with !!desc.set as well here...
      enumerable: desc.enumerable,
      value: base[key]
    };
  }
  return Object.create(getPrototypeOf(base), descriptors);
}
function freeze(obj) {
  let deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
  if (getArchtype(obj) > 1) {
    obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
  }
  Object.freeze(obj);
  if (deep) each(obj, (_key, value) => freeze(value, true));
  return obj;
}
function dontMutateFrozenCollections() {
  die(2);
}
function isFrozen(obj) {
  return Object.isFrozen(obj);
}

// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
  const plugin = plugins[pluginKey];
  if (!plugin) {
    die(0);
  }
  return plugin;
}

// src/core/scope.ts
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(parent_, immer_) {
  return {
    drafts_: [],
    parent_,
    immer_,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: true,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(scope, patchListener) {
  if (patchListener) {
    getPlugin("Patches");
    scope.patches_ = [];
    scope.inversePatches_ = [];
    scope.patchListener_ = patchListener;
  }
}
function revokeScope(scope) {
  leaveScope(scope);
  scope.drafts_.forEach(revokeDraft);
  scope.drafts_ = null;
}
function leaveScope(scope) {
  if (scope === currentScope) {
    currentScope = scope.parent_;
  }
}
function enterScope(immer2) {
  return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
  const state = draft[DRAFT_STATE];
  if (state.type_ === 0 /* Object */ || state.type_ === 1 /* Array */) state.revoke_();else state.revoked_ = true;
}

// src/core/finalize.ts
function processResult(result, scope) {
  scope.unfinalizedDrafts_ = scope.drafts_.length;
  const baseDraft = scope.drafts_[0];
  const isReplaced = result !== void 0 && result !== baseDraft;
  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified_) {
      revokeScope(scope);
      die(4);
    }
    if (isDraftable(result)) {
      result = finalize(scope, result);
      if (!scope.parent_) maybeFreeze(scope, result);
    }
    if (scope.patches_) {
      getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    }
  } else {
    result = finalize(scope, baseDraft, []);
  }
  revokeScope(scope);
  if (scope.patches_) {
    scope.patchListener_(scope.patches_, scope.inversePatches_);
  }
  return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
  if (isFrozen(value)) return value;
  const state = value[DRAFT_STATE];
  if (!state) {
    each(value, (key, childValue) => finalizeProperty(rootScope, state, value, key, childValue, path));
    return value;
  }
  if (state.scope_ !== rootScope) return value;
  if (!state.modified_) {
    maybeFreeze(rootScope, state.base_, true);
    return state.base_;
  }
  if (!state.finalized_) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
    const result = state.copy_;
    let resultEach = result;
    let isSet2 = false;
    if (state.type_ === 3 /* Set */) {
      resultEach = new Set(result);
      result.clear();
      isSet2 = true;
    }
    each(resultEach, (key, childValue) => finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
    maybeFreeze(rootScope, result, false);
    if (path && rootScope.patches_) {
      getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
  }
  return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
  if (isDraft(childValue)) {
    const path = rootPath && parentState && parentState.type_ !== 3 /* Set */ &&
    // Set objects are atomic since they have no keys.
    !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
    const res = finalize(rootScope, childValue, path);
    set(targetObject, prop, res);
    if (isDraft(res)) {
      rootScope.canAutoFreeze_ = false;
    } else return;
  } else if (targetIsSet) {
    targetObject.add(childValue);
  }
  if (isDraftable(childValue) && !isFrozen(childValue)) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
      return;
    }
    finalize(rootScope, childValue);
    if (!parentState || !parentState.scope_.parent_) maybeFreeze(rootScope, childValue);
  }
}
function maybeFreeze(scope, value) {
  let deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) {
    freeze(value, deep);
  }
}

// src/core/proxy.ts
function createProxyProxy(base, parent) {
  const isArray = Array.isArray(base);
  const state = {
    type_: isArray ? 1 /* Array */ : 0 /* Object */,

    // Track which produce call this is associated with.
    scope_: parent ? parent.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: false,
    // Used during finalization.
    finalized_: false,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: parent,
    // The base state.
    base_: base,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: false
  };
  let target = state;
  let traps = objectTraps;
  if (isArray) {
    target = [state];
    traps = arrayTraps;
  }
  const {
    revoke,
    proxy
  } = Proxy.revocable(target, traps);
  state.draft_ = proxy;
  state.revoke_ = revoke;
  return proxy;
}
var objectTraps = {
  get(state, prop) {
    if (prop === DRAFT_STATE) return state;
    const source = latest(state);
    if (!has(source, prop)) {
      return readPropFromProto(state, source, prop);
    }
    const value = source[prop];
    if (state.finalized_ || !isDraftable(value)) {
      return value;
    }
    if (value === peek(state.base_, prop)) {
      prepareCopy(state);
      return state.copy_[prop] = createProxy(value, state);
    }
    return value;
  },
  has(state, prop) {
    return prop in latest(state);
  },
  ownKeys(state) {
    return Reflect.ownKeys(latest(state));
  },
  set(state, prop, value) {
    const desc = getDescriptorFromProto(latest(state), prop);
    if (desc !== null && desc !== void 0 && desc.set) {
      desc.set.call(state.draft_, value);
      return true;
    }
    if (!state.modified_) {
      const current2 = peek(latest(state), prop);
      const currentState = current2 === null || current2 === void 0 ? void 0 : current2[DRAFT_STATE];
      if (currentState && currentState.base_ === value) {
        state.copy_[prop] = value;
        state.assigned_[prop] = false;
        return true;
      }
      if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
      prepareCopy(state);
      markChanged(state);
    }
    if (state.copy_[prop] === value && (
    // special case: handle new props with value 'undefined'
    value !== void 0 || prop in state.copy_) ||
    // special case: NaN
    Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
    state.copy_[prop] = value;
    state.assigned_[prop] = true;
    return true;
  },
  deleteProperty(state, prop) {
    if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
      state.assigned_[prop] = false;
      prepareCopy(state);
      markChanged(state);
    } else {
      delete state.assigned_[prop];
    }
    if (state.copy_) {
      delete state.copy_[prop];
    }
    return true;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(state, prop) {
    const owner = latest(state);
    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (!desc) return desc;
    return {
      writable: true,
      configurable: state.type_ !== 1 /* Array */ || prop !== "length",
      enumerable: desc.enumerable,
      value: owner[prop]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(state) {
    return getPrototypeOf(state.base_);
  },
  setPrototypeOf() {
    die(12);
  }
};
var arrayTraps = {};
each(objectTraps, (key, fn) => {
  arrayTraps[key] = function () {
    arguments[0] = arguments[0][0];
    return fn.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function (state, prop) {
  return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function (state, prop, value) {
  return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
  const state = draft[DRAFT_STATE];
  const source = state ? latest(state) : draft;
  return source[prop];
}
function readPropFromProto(state, source, prop) {
  var _desc$get;
  const desc = getDescriptorFromProto(source, prop);
  return desc ? "value" in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
  // prototype, we should invoke it with the draft as context!
  (_desc$get = desc.get) === null || _desc$get === void 0 ? void 0 : _desc$get.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
  if (!(prop in source)) return void 0;
  let proto = getPrototypeOf(source);
  while (proto) {
    const desc = Object.getOwnPropertyDescriptor(proto, prop);
    if (desc) return desc;
    proto = getPrototypeOf(proto);
  }
  return void 0;
}
function markChanged(state) {
  if (!state.modified_) {
    state.modified_ = true;
    if (state.parent_) {
      markChanged(state.parent_);
    }
  }
}
function prepareCopy(state) {
  if (!state.copy_) {
    state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
  }
}

// src/core/immerClass.ts
var Immer2 = class {
  constructor(config) {
    var _this = this;
    this.autoFreeze_ = true;
    this.useStrictShallowCopy_ = false;
    /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */
    this.produce = (base, recipe, patchListener) => {
      if (typeof base === "function" && typeof recipe !== "function") {
        const defaultBase = recipe;
        recipe = base;
        const self = this;
        return function curriedProduce() {
          let base2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultBase;
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key3 = 1; _key3 < _len2; _key3++) {
            args[_key3 - 1] = arguments[_key3];
          }
          return self.produce(base2, draft => recipe.call(this, draft, ...args));
        };
      }
      if (typeof recipe !== "function") die(6);
      if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
      let result;
      if (isDraftable(base)) {
        const scope = enterScope(this);
        const proxy = createProxy(base, void 0);
        let hasError = true;
        try {
          result = recipe(proxy);
          hasError = false;
        } finally {
          if (hasError) revokeScope(scope);else leaveScope(scope);
        }
        usePatchesInScope(scope, patchListener);
        return processResult(result, scope);
      } else if (!base || typeof base !== "object") {
        result = recipe(base);
        if (result === void 0) result = base;
        if (result === NOTHING) result = void 0;
        if (this.autoFreeze_) freeze(result, true);
        if (patchListener) {
          const p = [];
          const ip = [];
          getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
          patchListener(p, ip);
        }
        return result;
      } else die(1);
    };
    this.produceWithPatches = (base, recipe) => {
      if (typeof base === "function") {
        return function (state) {
          for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key4 = 1; _key4 < _len3; _key4++) {
            args[_key4 - 1] = arguments[_key4];
          }
          return _this.produceWithPatches(state, draft => base(draft, ...args));
        };
      }
      let patches, inversePatches;
      const result = this.produce(base, recipe, (p, ip) => {
        patches = p;
        inversePatches = ip;
      });
      return [result, patches, inversePatches];
    };
    if (typeof (config === null || config === void 0 ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
    if (typeof (config === null || config === void 0 ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
  }
  createDraft(base) {
    if (!isDraftable(base)) die(8);
    if (isDraft(base)) base = current(base);
    const scope = enterScope(this);
    const proxy = createProxy(base, void 0);
    proxy[DRAFT_STATE].isManual_ = true;
    leaveScope(scope);
    return proxy;
  }
  finishDraft(draft, patchListener) {
    const state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual_) die(9);
    const {
      scope_: scope
    } = state;
    usePatchesInScope(scope, patchListener);
    return processResult(void 0, scope);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(value) {
    this.autoFreeze_ = value;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(value) {
    this.useStrictShallowCopy_ = value;
  }
  applyPatches(base, patches) {
    let i;
    for (i = patches.length - 1; i >= 0; i--) {
      const patch = patches[i];
      if (patch.path.length === 0 && patch.op === "replace") {
        base = patch.value;
        break;
      }
    }
    if (i > -1) {
      patches = patches.slice(i + 1);
    }
    const applyPatchesImpl = getPlugin("Patches").applyPatches_;
    if (isDraft(base)) {
      return applyPatchesImpl(base, patches);
    }
    return this.produce(base, draft => applyPatchesImpl(draft, patches));
  }
};
function createProxy(value, parent) {
  const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
  const scope = parent ? parent.scope_ : getCurrentScope();
  scope.drafts_.push(draft);
  return draft;
}

// src/core/current.ts
function current(value) {
  if (!isDraft(value)) die(10);
  return currentImpl(value);
}
function currentImpl(value) {
  if (!isDraftable(value) || isFrozen(value)) return value;
  const state = value[DRAFT_STATE];
  let copy;
  if (state) {
    if (!state.modified_) return state.base_;
    state.finalized_ = true;
    copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
  } else {
    copy = shallowCopy(value, true);
  }
  each(copy, (key, childValue) => {
    set(copy, key, currentImpl(childValue));
  });
  if (state) {
    state.finalized_ = false;
  }
  return copy;
}

// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
immer.setUseStrictShallowCopy.bind(immer);
immer.applyPatches.bind(immer);
immer.createDraft.bind(immer);
immer.finishDraft.bind(immer);

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}
typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const isReplayTextLayer = layer => layer.type === 'text';
const isReplayVideoLayer = layer => layer.type === 'video';
const isReplayAudioLayer = layer => layer.type === 'audio';
const isReplayShapeLayer = layer => layer.type === 'shape';
const isReplayImageLayer = layer => layer.type === 'image';
setAutoFreeze(false);

const changeTheResourceUrl = resource => {
  if (!resource.location.includes(baseUrl)) {
    return resource;
  }
  const {
    search
  } = new URL(resource.location);
  const params = new URLSearchParams(search);
  return {
    ...resource,
    location: params.get(fileQuery)
  };
};
const removeLocalServerUrlsFromResources = layer => {
  if (isReplayTextLayer(layer)) {
    layer.props.font.value = changeTheResourceUrl(layer.props.font.value);
    return layer;
  }
  if (isReplayImageLayer(layer)) {
    layer.props.image.value = changeTheResourceUrl(layer.props.image.value);
    return layer;
  }
  if (isReplayShapeLayer(layer)) {
    layer.props.shape.value = changeTheResourceUrl(layer.props.shape.value);
    return layer;
  }
  if (isReplayVideoLayer(layer)) {
    layer.props.video.value = changeTheResourceUrl(layer.props.video.value);
    return layer;
  }
  if (isReplayAudioLayer(layer)) {
    layer.props.audio.value = changeTheResourceUrl(layer.props.audio.value);
    return layer;
  }
  return layer;
};

const exportLayers = async layers => {
  const layersWithoutLocalServerUrls = layers.map(layer => removeLocalServerUrlsFromResources(layer));
  return exportFiles({
    layers: layersWithoutLocalServerUrls
  });
};

const subscribeToEvent = callback => {
  return onCustomEvent(async _ref => {
    let {
      data,
      sid
    } = _ref;
    const result = await callback(JSON.parse(data));
    if (typeof result === 'undefined') return;
    await publishEvent$1({
      data: JSON.stringify(result),
      sid
    });
  });
};

const requestPermission = async (permissionType, requestIfRejected) => {
  if (!isAndroid() && !isIOS()) {
    return Promise.reject('Unsupported platform');
  }
  const sid = createRequestPermissionSid();
  return new Promise(async (resolve, reject) => {
    const result = await requestPermission$1(sid, permissionType, requestIfRejected);
    if (result.errorMessage) {
      reject(result.errorMessage);
    }
    sidMap.set(sid, resolve);
  });
};

const getRemoteSettings = async (name, tag) => {
  const remoteSettingsKey = createRemoteSettingsSid(name, tag);
  const remoteSettingsPromiseKey = createRemoteSettingsPromiseSid(name, tag);
  if (sidMap.has(remoteSettingsPromiseKey)) {
    return sidMap.get(remoteSettingsPromiseKey);
  }
  const promise = new Promise(resolve => sidMap.set(remoteSettingsKey, resolve));
  sidMap.set(remoteSettingsPromiseKey, promise);

  // NOTE:: the type guard here is because in the web remote settings the tag is required,
  // but on native platform it is optional
  await sendRemoteSettingsRequest({
    name,
    tag: tag
  });
  return promise;
};

const generateResultImage = async (layerId, options) => {
  const sid = createGenerateResultSid();
  return new Promise(async (resolve, reject) => {
    const result = await generateResultImage$1({
      sid,
      layerId,
      options
    });
    if (result.errorMessage) {
      reject(result.errorMessage);
    }
    sidMap.set(sid, resolve);
  });
};

const handleFileChooserOpen = params => {
  openFileChooser(params);
  return new Promise(resolve => {
    const unsubscribe = onOpenFileChooserResponse(_ref => {
      let {
        resources
      } = _ref;
      unsubscribe();
      resolve(resources);
    });
  });
};

const fetchAlbums = async () => {
  const sid = createFetchAlbumsSid();
  return new Promise(async (resolve, reject) => {
    const result = await fetchAlbums$1({
      sid
    });
    if (result.errorMessage) {
      reject(result.errorMessage);
    }
    sidMap.set(sid, resolve);
  });
};
const fetchMediaAssets = async params => {
  const sid = createFetchMediaAssetsSid();
  return new Promise(async (resolve, reject) => {
    const result = await fetchMediaAssets$1({
      sid,
      params
    });
    if (result.errorMessage) {
      reject(result.errorMessage);
    }
    sidMap.set(sid, resolve);
  });
};

const openRef = {
  current: []
};
const authRedirectRef = {
  current: []
};
const chooserResponseRef = {
  current: []
};
const playRef = {
  current: []
};
const onOpen = callback => {
  if (internalContext.bootstrapCame) {
    callback();
    return noop$1;
  }
  openRef.current.push(callback);
  return () => {
    openRef.current = openRef.current.filter(cb => cb !== callback);
  };
};

// NOTE:: is not implemented
const onPlay = callback => {
  playRef.current.push(callback);
  return () => {
    playRef.current = playRef.current.filter(cb => cb !== callback);
  };
};
const onAuthRedirect = callback => {
  authRedirectRef.current.push(callback);
  return () => {
    authRedirectRef.current = authRedirectRef.current.filter(cb => cb !== callback);
  };
};
const onChooserResponse = callback => {
  chooserResponseRef.current.push(callback);
  return () => {
    chooserResponseRef.current = chooserResponseRef.current.filter(cb => cb !== callback);
  };
};
const runOnOpenHandlers = async () => openRef.current.map(cb => cb());
const runChooserResponseHandlers = async _ref => {
  let {
    resources
  } = _ref;
  chooserResponseRef.current.map(cb => cb(resources));
};
const runAuthRedirectHandlers = async credentials => authRedirectRef.current.map(cb => cb(credentials));

function createHandlersContext(context) {
  let cbStack = [];
  onClose(async () => {
    await Promise.all(cbStack.map(cb => cb()));
    close({});
  });
  return Object.assign(context, {
    handlers: {
      close,
      onPlay,
      isIOS,
      isWeb,
      share,
      onOpen,
      navigate,
      isAndroid,
      raiseError,
      isWindows,
      download,
      fetchAlbums,
      exportLayers,
      publishEvent,
      sendAnalytics: data => sendAnalytics({
        data
      }),
      onDeactivate,
      onAuthRedirect,
      onChooserResponse,
      onSyncRequest,
      fetchMediaAssets,
      subscribeToEvent,
      requestPermission,
      getRemoteSettings,
      redirectToPackageId,
      generateResultImage,
      redirectToAuth: redirect,
      onClose: cb => {
        cbStack.push(cb);
        return () => cbStack = cbStack.filter(item => item !== cb);
      },
      openFileChooser: handleFileChooserOpen,
      onHeadersUpdate: cb => internalContext.onUpdate('apiHeaders', cb)
    }
  });
}

const defaultState = {};

function createInternalsContext(context) {
  let state = defaultState;
  let permanentState = defaultState;
  return Object.assign(context, {
    internals: {
      getState() {
        let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return params.permanent ? permanentState : state;
      },
      setState(nextState) {
        let {
          permanent = false,
          rerender = true
        } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (permanent) {
          permanentState = nextState;
          return save({
            state: JSON.stringify(state)
          });
        } else {
          state = nextState;
        }
        rerender && internalContext.ui.dispatch([]);
        return Promise.resolve({
          success: true
        });
      },
      getPlatformSDKVersion: () => internalContext.privateAPIVersion,
      getSDKVersion: () => SDK_VERSION
    }
  });
}

const createSharedStorage = () => {
  const model = createModel({});
  const dispatchBackUp = model.dispatch;
  model.dispatch = function (value) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const sid = createSharedStorageSid();
    return new Promise(resolve => {
      sidMap.set(sid, resolve);
      dispatchBackUp(value, {
        ...options,
        [DISPATCH_SHARED_STORAGE_SID_KEY]: sid
      });
    });
  };
  return model;
};

const convertObjectIntoQuerySearch = params => {
  const search = Object.entries(params);
  const searchParams = new URLSearchParams();
  search.forEach(_ref => {
    let [key, value] = _ref;
    if (Array.isArray(value)) {
      value.forEach(val => searchParams.append(key, val));
    } else {
      searchParams.append(key, value);
    }
  });
  return searchParams.toString();
};

const locationModel = createModel({
  params: {},
  route: '/'
});
const backupDispatch = locationModel.dispatch;
const createLocation = () => {
  if (isWebProtocol()) {
    locationModel.dispatch = async (nextLocationValue, options) => {
      const {
        params,
        route
      } = nextLocationValue;
      const search = convertObjectIntoQuerySearch(params);
      const sid = createLocationSid({
        pathname: route,
        search
      });
      sidMap.set(sid, options);
      syncContext({
        location: {
          pathname: route,
          search
        }
      });
    };
  }
  return locationModel;
};
const updateLocation = backupDispatch;

function createGeneralContext(context) {
  return Object.assign(context, {
    general: {
      auth: createModel({}),
      location: createLocation(),
      sharedStorage: createSharedStorage(),
      theme: createModel('light'),
      language: createModel('en')
    }
  });
}

const createSync = context => async replayActionParams => {
  const replayWithLocalServerUrls = produce(context.scene.replay, draftReplay => {
    draftReplay.context.layers = Object.keys(draftReplay.context.layers).reduce((acc, key) => {
      acc[key] = removeLocalServerUrlsFromResources(draftReplay.context.layers[key]);
      return acc;
    }, {});
  });
  return syncContext({
    replay: replayWithLocalServerUrls,
    selectedLayerIds: context.scene.selectedLayerIds,
    replayActionParams
  });
};

const subscriptions$2 = new Map();
const onLayersChange = (callback, options) => {
  subscriptions$2.set(callback, options || {});
  return () => {
    subscriptions$2.delete(callback);
  };
};
const runRequiredListeners$2 = patches => {
  subscriptions$2.forEach((options, callback) => {
    if (options.once) {
      subscriptions$2.delete(callback);
    }
    if (options.ids) {
      var _patches$remove, _patches$edit, _modifiedPatches$remo, _modifiedPatches$edit;
      // identifying which actual layers of interest has been changed
      const removedLayerIdsInInterest = ((_patches$remove = patches.remove) === null || _patches$remove === void 0 || (_patches$remove = _patches$remove.layerIds) === null || _patches$remove === void 0 ? void 0 : _patches$remove.filter(id => {
        var _options$ids;
        return (_options$ids = options.ids) === null || _options$ids === void 0 ? void 0 : _options$ids.includes(id);
      })) || [];
      const editedLayerIdsInInterest = ((_patches$edit = patches.edit) === null || _patches$edit === void 0 || (_patches$edit = _patches$edit.layers) === null || _patches$edit === void 0 ? void 0 : _patches$edit.filter(_ref => {
        var _options$ids2;
        let {
          uuid
        } = _ref;
        return (_options$ids2 = options.ids) === null || _options$ids2 === void 0 ? void 0 : _options$ids2.includes(uuid);
      })) || [];
      const modifiedPatches = {
        ...(!!removedLayerIdsInInterest.length && {
          remove: {
            layerIds: removedLayerIdsInInterest
          }
        }),
        ...(!!editedLayerIdsInInterest.length && {
          edit: {
            layers: editedLayerIdsInInterest
          }
        })
      };
      const hasChanges = !!((_modifiedPatches$remo = modifiedPatches.remove) !== null && _modifiedPatches$remo !== void 0 && (_modifiedPatches$remo = _modifiedPatches$remo.layerIds) !== null && _modifiedPatches$remo !== void 0 && _modifiedPatches$remo.length) || !!((_modifiedPatches$edit = modifiedPatches.edit) !== null && _modifiedPatches$edit !== void 0 && (_modifiedPatches$edit = _modifiedPatches$edit.layers) !== null && _modifiedPatches$edit !== void 0 && _modifiedPatches$edit.length);
      if (hasChanges) {
        callback(modifiedPatches);
      }
    } else {
      callback(patches);
    }
  });
};
const detectLayersChanges = (context, replay) => {
  if (replay && context.scene.replay.actions.length !== (replay === null || replay === void 0 ? void 0 : replay.actions.length)) {
    const lastAction = replay.actions[replay.actions.length - 1];
    runRequiredListeners$2(lastAction.update);
  }
};

const subscriptions$1 = new Map();
const onLayoutChange = (callback, options) => {
  subscriptions$1.set(callback, options || {});
  return () => {
    subscriptions$1.delete(callback);
  };
};
const runRequiredListeners$1 = layout => {
  subscriptions$1.forEach((options, callback) => {
    if (options.once) {
      subscriptions$1.delete(callback);
    }
    callback(layout);
  });
};
const detectLayoutChanges = (context, replay) => {
  if (replay && context.scene.replay.actions.length !== (replay === null || replay === void 0 ? void 0 : replay.actions.length)) {
    var _lastAction$update$ed;
    const lastAction = replay.actions[replay.actions.length - 1];
    if ((_lastAction$update$ed = lastAction.update.edit) !== null && _lastAction$update$ed !== void 0 && _lastAction$update$ed.layout) {
      var _lastAction$update$ed2;
      runRequiredListeners$1((_lastAction$update$ed2 = lastAction.update.edit) === null || _lastAction$update$ed2 === void 0 ? void 0 : _lastAction$update$ed2.layout);
    }
  }
};

const subscriptions = new Map();
const onSelectionChange = (callback, options) => {
  subscriptions.set(callback, options || {});
  return () => {
    subscriptions.delete(callback);
  };
};
const runRequiredListeners = patches => {
  subscriptions.forEach((options, callback) => {
    if (options.once) {
      subscriptions.delete(callback);
    }
    callback(patches);
  });
};
const detectSelectionChanges = (context, selectedLayerIds) => {
  if (context.scene.selectedLayerIds.length !== selectedLayerIds.length || !context.scene.selectedLayerIds.every(selectedLayerId => selectedLayerIds.includes(selectedLayerId))) {
    runRequiredListeners(selectedLayerIds);
  }
};

const createSceneContext = context => {
  return Object.assign(context, {
    scene: {
      replay: {
        actions: [],
        context: {
          layers: {},
          layout: {
            width: 0,
            height: 0
          },
          projectGroupId: ''
        },
        meta: {},
        settings: {}
      },
      selectedLayerIds: [],
      sync: createSync(context),
      onLayersChange,
      onLayoutChange,
      onSelectionChange,
      updateReplay: callback => {
        context.scene.replay = produce(context.scene.replay, callback);
      },
      hasLayerMediaType: (layer, mediaType) => layer.mediaType === mediaType
    }
  });
};

const BASE_URL = process.env.REACT_APP_API_URL || 'https://api.picsart.com/stage';

// monetization
const PENDING_GENERATION_URL = "".concat(BASE_URL, "/guard/feature/pending-uses");
const COMMIT_GENERATION_URL = "".concat(BASE_URL, "/guard/feature/pending-uses/commit");
const ROLLBACK_GENERATION_URL = "".concat(BASE_URL, "/guard/feature/pending-uses/rollback");
const PENDING_CREDIT_URL = "".concat(BASE_URL, "/guard/credits/pending-uses");
const COMMIT_CREDIT_URL = "".concat(BASE_URL, "/guard/credits/pending-uses/commit");
const ROLLBACK_CREDIT_URL = "".concat(BASE_URL, "/guard/credits/pending-uses/rollback");
const FEATURES_URL = "".concat(BASE_URL, "/shop/subscription/features");

let AnalyticsEvent = /*#__PURE__*/function (AnalyticsEvent) {
  AnalyticsEvent["MINIAPP_READY"] = "miniapp_ready";
  AnalyticsEvent["MINIAPP_LOAD"] = "miniapp_load";
  AnalyticsEvent["TIME_TO_INTERACT"] = "time_to_interact";
  AnalyticsEvent["AI_CREDIT_PENDING_REQUEST"] = "ai_credit_pending_request";
  AnalyticsEvent["AI_CREDIT_PENDING_COMMIT_REQUEST"] = "ai_credit_pending_commit_request";
  AnalyticsEvent["AI_CREDIT_PENDING_ROLLBACK_REQUEST"] = "ai_credit_pending_rollback_request";
  AnalyticsEvent["AI_CREDIT_FEATURES_REQUEST"] = "ai_credit_features_request";
  return AnalyticsEvent;
}({});

const getTypeUrl = areCreditsAvailable => ({
  rollback: areCreditsAvailable ? ROLLBACK_CREDIT_URL : ROLLBACK_GENERATION_URL,
  pending: areCreditsAvailable ? PENDING_CREDIT_URL : PENDING_GENERATION_URL,
  commit: areCreditsAvailable ? COMMIT_CREDIT_URL : COMMIT_GENERATION_URL
});
const analyticsMap = {
  rollback: AnalyticsEvent.AI_CREDIT_PENDING_ROLLBACK_REQUEST,
  commit: AnalyticsEvent.AI_CREDIT_PENDING_COMMIT_REQUEST,
  pending: AnalyticsEvent.AI_CREDIT_PENDING_REQUEST
};
fetchWrapper(FEATURES_URL).then(res => res.json()).then(res => {
  sendAnalytics({
    data: {
      eventName: AnalyticsEvent.AI_CREDIT_FEATURES_REQUEST,
      params: {
        status: res.status,
        fail_reason: res.reason
      }
    }
  });
  if (res.status === 'success') {
    internalContext.toolPrices = res.response;
  }
});
const updateGeneration = async _ref => {
  let {
    type,
    toolId,
    areCreditsAvailable,
    used = 1,
    transactionId
  } = _ref;
  const response = await fetchWrapper(getTypeUrl(areCreditsAvailable)[type], {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(areCreditsAvailable && type !== 'pending' ? {
      transactionId
    } : {
      feature_id: toolId,
      used
    })
  });
  const resp = await response.json();
  if (resp.status === 'success' && areCreditsAvailable) {
    var _internalContext$tool;
    sendAnalytics({
      data: {
        eventName: analyticsMap[type],
        params: {
          status: resp.status,
          transaction_id: type === 'pending' ? resp.response.transactionId : transactionId,
          feature_id: toolId,
          fail_reason: resp.response.reason,
          credit_count: resp.response.credits,
          addon_credits: resp.response.addonCredits,
          feature_credit: (_internalContext$tool = internalContext.toolPrices) === null || _internalContext$tool === void 0 || (_internalContext$tool = _internalContext$tool.find(tool => tool.id === toolId)) === null || _internalContext$tool === void 0 ? void 0 : _internalContext$tool.credit_price,
          is_miniapp: true
        }
      }
    });
  }
  if (resp.status === 'success' && areCreditsAvailable) {
    await syncContext({
      credits: {
        creditsInfo: resp.response,
        toolId
      }
    });
  }
  return resp;
};
const syncCredits = async _ref2 => {
  let {
    credits,
    toolId
  } = _ref2;
  return await syncContext({
    credits: {
      creditsInfo: credits,
      toolId
    }
  });
};
const setPendingGeneration = async props => {
  const res = await updateGeneration({
    type: 'pending',
    ...props
  });
  if (res.status === 'success') {
    return {
      commit: () => commitGeneration({
        transactionId: res.response.transactionId,
        ...props
      }),
      rollback: () => rollbackGeneration({
        transactionId: res.response.transactionId,
        ...props
      }),
      ...res
    };
  }
  return res;
};
const commitGeneration = props => updateGeneration({
  type: 'commit',
  ...props
});
const rollbackGeneration = props => updateGeneration({
  type: 'rollback',
  ...props
});

function createMonetizationContext(context) {
  return Object.assign(context, {
    monetization: {
      credits: createModel({}),
      pending: setPendingGeneration,
      rollback: rollbackGeneration,
      commit: commitGeneration,
      syncCredits
    }
  });
}

function createBaseContext() {
  onCustomEvent(handleCustomEvent);
  return pipeline(createMonetizationContext, createGeneralContext, createUtilsContext, createInternalsContext, createLayoutContext, createHandlersContext, createSceneContext)({});
}

window.addEventListener('error', event => {
  raiseError({
    reason: "UNHANDLED ERROR: ".concat(event.type, ": ").concat(event.message)
  });
});

const searchParams = new URLSearchParams(window.location.search);
// Extract and add version information to the internal context.

const queryPlatformVersion = searchParams.get('platform_version');
const sid = searchParams.get('sid');
if (queryPlatformVersion) {
  internalContext.privateAPIVersion = queryPlatformVersion;
}
if (sid) {
  internalContext.sid = sid;
}

const convertQuerySearchIntoObject = query => [...new URLSearchParams(query).entries()].reduce((acc, _ref) => {
  let [key, value] = _ref;
  if (acc[key]) {
    acc[key] = [acc[key]];
    acc[key].push(value);
    return acc;
  }
  acc[key] = value;
  return acc;
}, {});

const defaultLoader = (payload, cb) => cb();
const bootstraper = function () {
  let loader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultLoader;
  onBootstrap(payload => {
    window.bootstrapTime = performance.now();

    /* Add the session id to the internal context.
     * This will be sent with each request to the native platform
     * to identify the source miniapp that sent the message.
     */
    internalContext.sid = payload.sid;
    loader(payload, () => {
      sendAnalytics({
        data: {
          eventName: AnalyticsEvent.MINIAPP_LOAD,
          params: {
            load_time: performance.now() - window.bootstrapTime,
            privateAPIVersion: internalContext.privateAPIVersion
          }
        }
      });
    });
    const [extension] = payload.miniapp.extensions;
    internalContext.setExtensionType(extension.type);
  });
  onAuthRedirectResponse(payload => {
    const authCredentials = {
      query: convertQuerySearchIntoObject(payload.query),
      redirectUrl: payload.redirectUrl,
      signature: payload.signature
    };
    internalContext.authModel.dispatch(authCredentials);
  });
};

const postOpenHandler = async loadStartTimestamp => {
  if (loadStartTimestamp) {
    sendAnalytics({
      data: {
        eventName: AnalyticsEvent.TIME_TO_INTERACT,
        params: {
          load_time: Date.now() - loadStartTimestamp,
          scope_name: 'app_miniapp_load'
        }
      }
    });
  }
  await runOnOpenHandlers();
  await ready();
};

const deepCompare = (obj1, obj2) => {
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || !obj1 || !obj2) {
    return false;
  }

  // Get the keys of the objects
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Check if the number of keys is the same
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Check if all keys in obj1 exist in obj2
  for (const key of keys1) {
    if (!Object.prototype.hasOwnProperty.call(obj2, key)) {
      return false;
    }
  }

  // Check if the values of each key are deeply equal
  for (const key of keys1) {
    const value1 = obj1[key];
    const value2 = obj2[key];

    // If the value is an object, recursively compare
    if (typeof value1 === 'object' && typeof value2 === 'object') {
      if (!deepCompare(value1, value2)) {
        return false;
      }
    } else if (value1 !== value2) {
      // If the values are not deeply equal, return false
      return false;
    }
  }

  // If all checks pass, return true
  return true;
};

const contextUpdater = (context, _ref) => {
  var _rest$location, _rest$location2;
  let {
    theme,
    language,
    headers,
    user,
    sharedStorage,
    replay,
    credits,
    selectedLayerIds,
    ...rest
  } = _ref;
  if (headers) {
    internalContext.apiHeaders = headers;
  }
  theme && context.general.theme.dispatch(theme);
  language && context.general.language.dispatch(language);
  if (user) {
    context.general.auth.dispatch({
      ...user,
      isAuthorized: !!user.id,
      isSubscribed: !!user.isSubscribed
    });
  }
  if (credits) {
    if (!deepCompare(context.monetization.credits.getState(), credits)) {
      context.monetization.credits.dispatch(credits);
    }
  }
  if ((_rest$location = rest.location) !== null && _rest$location !== void 0 && _rest$location.pathname || ((_rest$location2 = rest.location) === null || _rest$location2 === void 0 ? void 0 : _rest$location2.search) !== undefined) {
    var _rest$location3, _rest$location4;
    const previousLocationValue = context.general.location.getState();
    const nextLocationPathname = ((_rest$location3 = rest.location) === null || _rest$location3 === void 0 ? void 0 : _rest$location3.pathname) || previousLocationValue.route;
    const nextLocationSearchParams = ((_rest$location4 = rest.location) === null || _rest$location4 === void 0 ? void 0 : _rest$location4.search) || convertObjectIntoQuerySearch(previousLocationValue.params);
    const sid = createLocationSid({
      pathname: nextLocationPathname,
      search: nextLocationSearchParams
    });
    const storedOptions = sidMap.get(sid);
    updateLocation({
      route: nextLocationPathname,
      params: convertQuerySearchIntoObject(nextLocationSearchParams)
    }, storedOptions);
  }
  // TODO:: move to migrations
  if (rest.search !== undefined) {
    const nextLocationPathname = context.general.location.getState().route;
    const nextLocationSearchParamsString = rest.search;
    const sid = createLocationSid({
      pathname: nextLocationPathname,
      search: nextLocationSearchParamsString
    });
    const storedOptions = sidMap.get(sid);
    updateLocation({
      route: nextLocationPathname,
      params: convertQuerySearchIntoObject(nextLocationSearchParamsString)
    }, storedOptions);
  }
  if (replay) {
    context.scene.replay = replay;
  }

  // if there are selected layers, and they are different from the previous ones, dispatch them
  if (selectedLayerIds) {
    context.scene.selectedLayerIds = selectedLayerIds;
  }
  if (replay) {
    detectLayoutChanges(context, replay);
    detectLayersChanges(context, replay);
  }
  if (selectedLayerIds) {
    detectSelectionChanges(context, selectedLayerIds);
  }
  sharedStorage && context.general.sharedStorage.dispatch(JSON.parse(sharedStorage), DISPATCH_SHARED_STORAGE_CONFIGS);
  internalContext.redraw();
};
const handleContextChange = (payload, context) => {
  contextUpdater(context, payload);
  onContextChange(payload => contextUpdater(context, payload));
};

const mainLogs = {
  initializing: 'Initializing...',
  close: 'Running "onClose" callbacks',
  context: 'Context has been created',
  bootstrap: 'Bootstrap message received',
  auth: 'Running "onAuthRedirect" callbacks',
  open: 'Ready state achieved, calling all the "onOpen" handlers'
};
const logger = message => console.log("%cMiniapps SDK ::: ".concat(message), 'color: #E859B4');

const generateResultImageHandler = _ref => {
  var _sidMap$get;
  let {
    resource,
    sid
  } = _ref;
  (_sidMap$get = sidMap.get(sid)) === null || _sidMap$get === void 0 || _sidMap$get(resource);
};

const handleMessageResolver = _ref => {
  var _sidMap$get;
  let {
    resolveId,
    ...rest
  } = _ref;
  return (_sidMap$get = sidMap.get(resolveId)) === null || _sidMap$get === void 0 ? void 0 : _sidMap$get(rest);
};

const listenToSharedStorageChanges = context => {
  context.general.sharedStorage.subscribe(async (nextValue, options) => {
    if (options && options[DISPATCH_SHARED_STORAGE_CONFIG_KEY]) return;
    const {
      [DISPATCH_SHARED_STORAGE_SID_KEY]: sid
    } = options || {};
    const resolver = sid && sidMap.get(sid);
    await syncContext({
      sharedStorage: JSON.stringify(nextValue)
    });
    resolver();
  });
};

const createLocalServerUrl = url => "".concat(baseUrl, "/storage?").concat(fileQuery, "=").concat(url);
const getImageUrl = function (url) {
  let from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return useLocalServer(url, from) ? createLocalServerUrl(url) : url;
};

const fetchAlbumsHandler = _ref => {
  var _sidMap$get;
  let {
    albums,
    sid
  } = _ref;
  (_sidMap$get = sidMap.get(sid)) === null || _sidMap$get === void 0 || _sidMap$get(albums);
};
const fetchMediaAssetsHandler = _ref2 => {
  var _sidMap$get2;
  let {
    assets,
    sid
  } = _ref2;
  assets.forEach(asset => {
    if (!asset.url.includes(':')) {
      //Check if it has scheme or not
      asset.url = getImageUrl(asset.url, false);
    }
    if (!asset.thumbnailUrl.includes(':')) {
      //Check if it has scheme or not
      asset.thumbnailUrl = getImageUrl(asset.thumbnailUrl, false);
    }
  });
  (_sidMap$get2 = sidMap.get(sid)) === null || _sidMap$get2 === void 0 || _sidMap$get2(assets);
};

const safeParse = data => {
  if (!data) return {};
  try {
    return JSON.parse(data);
  } catch (error) {
    raiseError({
      reason: "Failed to parse settings data: ".concat(error.toString())
    });
    return {};
  }
};
const remoteSettingsResponseHandler = _ref => {
  let {
    name,
    tag,
    settings
  } = _ref;
  const resolver = sidMap.get(createRemoteSettingsSid(name, tag));
  if (resolver) {
    resolver(safeParse(settings));
  }
};

const requestPermissionHandler = _ref => {
  var _sidMap$get;
  let {
    sid,
    result
  } = _ref;
  (_sidMap$get = sidMap.get(sid)) === null || _sidMap$get === void 0 || _sidMap$get(result);
};

const runListeners = context => {
  listenToSharedStorageChanges(context);
  onRemoteSettings(remoteSettingsResponseHandler);
  onResolveMessage(handleMessageResolver);
  onGeneratedResultImage(generateResultImageHandler);
  onFetchAlbums(fetchAlbumsHandler);
  onFetchMediaAssets(fetchMediaAssetsHandler);
  onOpenFileChooserResponse(runChooserResponseHandlers);
  onRequestPermission(requestPermissionHandler);
};
const authRedirectListener = () => {
  internalContext.authModel.subscribe(authCredentials => {
    if (authCredentials) {
      logger(mainLogs.auth);
      runAuthRedirectHandlers(authCredentials);
    }
  }, {
    needPrevious: true
  });
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spreadArray(to, from, pack) {
  if (arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []),
    i,
    q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i;
  function verb(n) {
    if (g[n]) i[n] = function (v) {
      return new Promise(function (a, b) {
        q.push([n, v, a, b]) > 1 || resume(n, v);
      });
    };
  }
  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle(q[0][3], e);
    }
  }
  function step(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }
  function fulfill(value) {
    resume("next", value);
  }
  function reject(value) {
    resume("throw", value);
  }
  function settle(f, v) {
    if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
}
function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator],
    i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i);
  function verb(n) {
    i[n] = o[n] && function (v) {
      return new Promise(function (resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }
  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function (v) {
      resolve({
        value: v,
        done: d
      });
    }, reject);
  }
}

function isFunction(value) {
  return typeof value === 'function';
}

function createErrorClass(createImpl) {
  var _super = function (instance) {
    Error.call(instance);
    instance.stack = new Error().stack;
  };
  var ctorFunc = createImpl(_super);
  ctorFunc.prototype = Object.create(Error.prototype);
  ctorFunc.prototype.constructor = ctorFunc;
  return ctorFunc;
}

var UnsubscriptionError = createErrorClass(function (_super) {
  return function UnsubscriptionErrorImpl(errors) {
    _super(this);
    this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) {
      return i + 1 + ") " + err.toString();
    }).join('\n  ') : '';
    this.name = 'UnsubscriptionError';
    this.errors = errors;
  };
});

function arrRemove(arr, item) {
  if (arr) {
    var index = arr.indexOf(item);
    0 <= index && arr.splice(index, 1);
  }
}

var Subscription = function () {
  function Subscription(initialTeardown) {
    this.initialTeardown = initialTeardown;
    this.closed = false;
    this._parentage = null;
    this._finalizers = null;
  }
  Subscription.prototype.unsubscribe = function () {
    var e_1, _a, e_2, _b;
    var errors;
    if (!this.closed) {
      this.closed = true;
      var _parentage = this._parentage;
      if (_parentage) {
        this._parentage = null;
        if (Array.isArray(_parentage)) {
          try {
            for (var _parentage_1 = __values(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
              var parent_1 = _parentage_1_1.value;
              parent_1.remove(this);
            }
          } catch (e_1_1) {
            e_1 = {
              error: e_1_1
            };
          } finally {
            try {
              if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
        } else {
          _parentage.remove(this);
        }
      }
      var initialFinalizer = this.initialTeardown;
      if (isFunction(initialFinalizer)) {
        try {
          initialFinalizer();
        } catch (e) {
          errors = e instanceof UnsubscriptionError ? e.errors : [e];
        }
      }
      var _finalizers = this._finalizers;
      if (_finalizers) {
        this._finalizers = null;
        try {
          for (var _finalizers_1 = __values(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()) {
            var finalizer = _finalizers_1_1.value;
            try {
              execFinalizer(finalizer);
            } catch (err) {
              errors = errors !== null && errors !== void 0 ? errors : [];
              if (err instanceof UnsubscriptionError) {
                errors = __spreadArray(__spreadArray([], __read(errors)), __read(err.errors));
              } else {
                errors.push(err);
              }
            }
          }
        } catch (e_2_1) {
          e_2 = {
            error: e_2_1
          };
        } finally {
          try {
            if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
          } finally {
            if (e_2) throw e_2.error;
          }
        }
      }
      if (errors) {
        throw new UnsubscriptionError(errors);
      }
    }
  };
  Subscription.prototype.add = function (teardown) {
    var _a;
    if (teardown && teardown !== this) {
      if (this.closed) {
        execFinalizer(teardown);
      } else {
        if (teardown instanceof Subscription) {
          if (teardown.closed || teardown._hasParent(this)) {
            return;
          }
          teardown._addParent(this);
        }
        (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
      }
    }
  };
  Subscription.prototype._hasParent = function (parent) {
    var _parentage = this._parentage;
    return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
  };
  Subscription.prototype._addParent = function (parent) {
    var _parentage = this._parentage;
    this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [_parentage, parent] : parent;
  };
  Subscription.prototype._removeParent = function (parent) {
    var _parentage = this._parentage;
    if (_parentage === parent) {
      this._parentage = null;
    } else if (Array.isArray(_parentage)) {
      arrRemove(_parentage, parent);
    }
  };
  Subscription.prototype.remove = function (teardown) {
    var _finalizers = this._finalizers;
    _finalizers && arrRemove(_finalizers, teardown);
    if (teardown instanceof Subscription) {
      teardown._removeParent(this);
    }
  };
  Subscription.EMPTY = function () {
    var empty = new Subscription();
    empty.closed = true;
    return empty;
  }();
  return Subscription;
}();
var EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(value) {
  return value instanceof Subscription || value && 'closed' in value && isFunction(value.remove) && isFunction(value.add) && isFunction(value.unsubscribe);
}
function execFinalizer(finalizer) {
  if (isFunction(finalizer)) {
    finalizer();
  } else {
    finalizer.unsubscribe();
  }
}

var config = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: undefined,
  useDeprecatedSynchronousErrorHandling: false,
  useDeprecatedNextContext: false
};

var timeoutProvider = {
  setTimeout: function (handler, timeout) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      args[_i - 2] = arguments[_i];
    }
    return setTimeout.apply(void 0, __spreadArray([handler, timeout], __read(args)));
  },
  clearTimeout: function (handle) {
    var delegate = timeoutProvider.delegate;
    return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
  },
  delegate: undefined
};

function reportUnhandledError(err) {
  timeoutProvider.setTimeout(function () {
    {
      throw err;
    }
  });
}

function noop() {}

function errorContext(cb) {
  {
    cb();
  }
}

var Subscriber = function (_super) {
  __extends(Subscriber, _super);
  function Subscriber(destination) {
    var _this = _super.call(this) || this;
    _this.isStopped = false;
    if (destination) {
      _this.destination = destination;
      if (isSubscription(destination)) {
        destination.add(_this);
      }
    } else {
      _this.destination = EMPTY_OBSERVER;
    }
    return _this;
  }
  Subscriber.create = function (next, error, complete) {
    return new SafeSubscriber(next, error, complete);
  };
  Subscriber.prototype.next = function (value) {
    if (this.isStopped) ; else {
      this._next(value);
    }
  };
  Subscriber.prototype.error = function (err) {
    if (this.isStopped) ; else {
      this.isStopped = true;
      this._error(err);
    }
  };
  Subscriber.prototype.complete = function () {
    if (this.isStopped) ; else {
      this.isStopped = true;
      this._complete();
    }
  };
  Subscriber.prototype.unsubscribe = function () {
    if (!this.closed) {
      this.isStopped = true;
      _super.prototype.unsubscribe.call(this);
      this.destination = null;
    }
  };
  Subscriber.prototype._next = function (value) {
    this.destination.next(value);
  };
  Subscriber.prototype._error = function (err) {
    try {
      this.destination.error(err);
    } finally {
      this.unsubscribe();
    }
  };
  Subscriber.prototype._complete = function () {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  };
  return Subscriber;
}(Subscription);
var _bind = Function.prototype.bind;
function bind(fn, thisArg) {
  return _bind.call(fn, thisArg);
}
var ConsumerObserver = function () {
  function ConsumerObserver(partialObserver) {
    this.partialObserver = partialObserver;
  }
  ConsumerObserver.prototype.next = function (value) {
    var partialObserver = this.partialObserver;
    if (partialObserver.next) {
      try {
        partialObserver.next(value);
      } catch (error) {
        handleUnhandledError(error);
      }
    }
  };
  ConsumerObserver.prototype.error = function (err) {
    var partialObserver = this.partialObserver;
    if (partialObserver.error) {
      try {
        partialObserver.error(err);
      } catch (error) {
        handleUnhandledError(error);
      }
    } else {
      handleUnhandledError(err);
    }
  };
  ConsumerObserver.prototype.complete = function () {
    var partialObserver = this.partialObserver;
    if (partialObserver.complete) {
      try {
        partialObserver.complete();
      } catch (error) {
        handleUnhandledError(error);
      }
    }
  };
  return ConsumerObserver;
}();
var SafeSubscriber = function (_super) {
  __extends(SafeSubscriber, _super);
  function SafeSubscriber(observerOrNext, error, complete) {
    var _this = _super.call(this) || this;
    var partialObserver;
    if (isFunction(observerOrNext) || !observerOrNext) {
      partialObserver = {
        next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
        error: error !== null && error !== void 0 ? error : undefined,
        complete: complete !== null && complete !== void 0 ? complete : undefined
      };
    } else {
      var context_1;
      if (_this && config.useDeprecatedNextContext) {
        context_1 = Object.create(observerOrNext);
        context_1.unsubscribe = function () {
          return _this.unsubscribe();
        };
        partialObserver = {
          next: observerOrNext.next && bind(observerOrNext.next, context_1),
          error: observerOrNext.error && bind(observerOrNext.error, context_1),
          complete: observerOrNext.complete && bind(observerOrNext.complete, context_1)
        };
      } else {
        partialObserver = observerOrNext;
      }
    }
    _this.destination = new ConsumerObserver(partialObserver);
    return _this;
  }
  return SafeSubscriber;
}(Subscriber);
function handleUnhandledError(error) {
  {
    reportUnhandledError(error);
  }
}
function defaultErrorHandler(err) {
  throw err;
}
var EMPTY_OBSERVER = {
  closed: true,
  next: noop,
  error: defaultErrorHandler,
  complete: noop
};

var observable = function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();

function identity(x) {
  return x;
}

function pipeFromArray(fns) {
  if (fns.length === 0) {
    return identity;
  }
  if (fns.length === 1) {
    return fns[0];
  }
  return function piped(input) {
    return fns.reduce(function (prev, fn) {
      return fn(prev);
    }, input);
  };
}

var Observable = function () {
  function Observable(subscribe) {
    if (subscribe) {
      this._subscribe = subscribe;
    }
  }
  Observable.prototype.lift = function (operator) {
    var observable = new Observable();
    observable.source = this;
    observable.operator = operator;
    return observable;
  };
  Observable.prototype.subscribe = function (observerOrNext, error, complete) {
    var _this = this;
    var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new SafeSubscriber(observerOrNext, error, complete);
    errorContext(function () {
      var _a = _this,
        operator = _a.operator,
        source = _a.source;
      subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
    });
    return subscriber;
  };
  Observable.prototype._trySubscribe = function (sink) {
    try {
      return this._subscribe(sink);
    } catch (err) {
      sink.error(err);
    }
  };
  Observable.prototype.forEach = function (next, promiseCtor) {
    var _this = this;
    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function (resolve, reject) {
      var subscriber = new SafeSubscriber({
        next: function (value) {
          try {
            next(value);
          } catch (err) {
            reject(err);
            subscriber.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
      _this.subscribe(subscriber);
    });
  };
  Observable.prototype._subscribe = function (subscriber) {
    var _a;
    return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
  };
  Observable.prototype[observable] = function () {
    return this;
  };
  Observable.prototype.pipe = function () {
    var operations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      operations[_i] = arguments[_i];
    }
    return pipeFromArray(operations)(this);
  };
  Observable.prototype.toPromise = function (promiseCtor) {
    var _this = this;
    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function (resolve, reject) {
      var value;
      _this.subscribe(function (x) {
        return value = x;
      }, function (err) {
        return reject(err);
      }, function () {
        return resolve(value);
      });
    });
  };
  Observable.create = function (subscribe) {
    return new Observable(subscribe);
  };
  return Observable;
}();
function getPromiseCtor(promiseCtor) {
  var _a;
  return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config.Promise) !== null && _a !== void 0 ? _a : Promise;
}
function isObserver(value) {
  return value && isFunction(value.next) && isFunction(value.error) && isFunction(value.complete);
}
function isSubscriber(value) {
  return value && value instanceof Subscriber || isObserver(value) && isSubscription(value);
}

function hasLift(source) {
  return isFunction(source === null || source === void 0 ? void 0 : source.lift);
}
function operate(init) {
  return function (source) {
    if (hasLift(source)) {
      return source.lift(function (liftedSource) {
        try {
          return init(liftedSource, this);
        } catch (err) {
          this.error(err);
        }
      });
    }
    throw new TypeError('Unable to lift unknown Observable type');
  };
}

function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
  return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
}
var OperatorSubscriber = function (_super) {
  __extends(OperatorSubscriber, _super);
  function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
    var _this = _super.call(this, destination) || this;
    _this.onFinalize = onFinalize;
    _this.shouldUnsubscribe = shouldUnsubscribe;
    _this._next = onNext ? function (value) {
      try {
        onNext(value);
      } catch (err) {
        destination.error(err);
      }
    } : _super.prototype._next;
    _this._error = onError ? function (err) {
      try {
        onError(err);
      } catch (err) {
        destination.error(err);
      } finally {
        this.unsubscribe();
      }
    } : _super.prototype._error;
    _this._complete = onComplete ? function () {
      try {
        onComplete();
      } catch (err) {
        destination.error(err);
      } finally {
        this.unsubscribe();
      }
    } : _super.prototype._complete;
    return _this;
  }
  OperatorSubscriber.prototype.unsubscribe = function () {
    var _a;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var closed_1 = this.closed;
      _super.prototype.unsubscribe.call(this);
      !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 ? void 0 : _a.call(this));
    }
  };
  return OperatorSubscriber;
}(Subscriber);

var ObjectUnsubscribedError = createErrorClass(function (_super) {
  return function ObjectUnsubscribedErrorImpl() {
    _super(this);
    this.name = 'ObjectUnsubscribedError';
    this.message = 'object unsubscribed';
  };
});

var Subject = function (_super) {
  __extends(Subject, _super);
  function Subject() {
    var _this = _super.call(this) || this;
    _this.closed = false;
    _this.currentObservers = null;
    _this.observers = [];
    _this.isStopped = false;
    _this.hasError = false;
    _this.thrownError = null;
    return _this;
  }
  Subject.prototype.lift = function (operator) {
    var subject = new AnonymousSubject(this, this);
    subject.operator = operator;
    return subject;
  };
  Subject.prototype._throwIfClosed = function () {
    if (this.closed) {
      throw new ObjectUnsubscribedError();
    }
  };
  Subject.prototype.next = function (value) {
    var _this = this;
    errorContext(function () {
      var e_1, _a;
      _this._throwIfClosed();
      if (!_this.isStopped) {
        if (!_this.currentObservers) {
          _this.currentObservers = Array.from(_this.observers);
        }
        try {
          for (var _b = __values(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()) {
            var observer = _c.value;
            observer.next(value);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
      }
    });
  };
  Subject.prototype.error = function (err) {
    var _this = this;
    errorContext(function () {
      _this._throwIfClosed();
      if (!_this.isStopped) {
        _this.hasError = _this.isStopped = true;
        _this.thrownError = err;
        var observers = _this.observers;
        while (observers.length) {
          observers.shift().error(err);
        }
      }
    });
  };
  Subject.prototype.complete = function () {
    var _this = this;
    errorContext(function () {
      _this._throwIfClosed();
      if (!_this.isStopped) {
        _this.isStopped = true;
        var observers = _this.observers;
        while (observers.length) {
          observers.shift().complete();
        }
      }
    });
  };
  Subject.prototype.unsubscribe = function () {
    this.isStopped = this.closed = true;
    this.observers = this.currentObservers = null;
  };
  Object.defineProperty(Subject.prototype, "observed", {
    get: function () {
      var _a;
      return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
    },
    enumerable: false,
    configurable: true
  });
  Subject.prototype._trySubscribe = function (subscriber) {
    this._throwIfClosed();
    return _super.prototype._trySubscribe.call(this, subscriber);
  };
  Subject.prototype._subscribe = function (subscriber) {
    this._throwIfClosed();
    this._checkFinalizedStatuses(subscriber);
    return this._innerSubscribe(subscriber);
  };
  Subject.prototype._innerSubscribe = function (subscriber) {
    var _this = this;
    var _a = this,
      hasError = _a.hasError,
      isStopped = _a.isStopped,
      observers = _a.observers;
    if (hasError || isStopped) {
      return EMPTY_SUBSCRIPTION;
    }
    this.currentObservers = null;
    observers.push(subscriber);
    return new Subscription(function () {
      _this.currentObservers = null;
      arrRemove(observers, subscriber);
    });
  };
  Subject.prototype._checkFinalizedStatuses = function (subscriber) {
    var _a = this,
      hasError = _a.hasError,
      thrownError = _a.thrownError,
      isStopped = _a.isStopped;
    if (hasError) {
      subscriber.error(thrownError);
    } else if (isStopped) {
      subscriber.complete();
    }
  };
  Subject.prototype.asObservable = function () {
    var observable = new Observable();
    observable.source = this;
    return observable;
  };
  Subject.create = function (destination, source) {
    return new AnonymousSubject(destination, source);
  };
  return Subject;
}(Observable);
var AnonymousSubject = function (_super) {
  __extends(AnonymousSubject, _super);
  function AnonymousSubject(destination, source) {
    var _this = _super.call(this) || this;
    _this.destination = destination;
    _this.source = source;
    return _this;
  }
  AnonymousSubject.prototype.next = function (value) {
    var _a, _b;
    (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.call(_a, value);
  };
  AnonymousSubject.prototype.error = function (err) {
    var _a, _b;
    (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, err);
  };
  AnonymousSubject.prototype.complete = function () {
    var _a, _b;
    (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a);
  };
  AnonymousSubject.prototype._subscribe = function (subscriber) {
    var _a, _b;
    return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : EMPTY_SUBSCRIPTION;
  };
  return AnonymousSubject;
}(Subject);

var dateTimestampProvider = {
  now: function () {
    return (Date).now();
  },
  delegate: undefined
};

var Action = function (_super) {
  __extends(Action, _super);
  function Action(scheduler, work) {
    return _super.call(this) || this;
  }
  Action.prototype.schedule = function (state, delay) {
    return this;
  };
  return Action;
}(Subscription);

var intervalProvider = {
  setInterval: function (handler, timeout) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      args[_i - 2] = arguments[_i];
    }
    return setInterval.apply(void 0, __spreadArray([handler, timeout], __read(args)));
  },
  clearInterval: function (handle) {
    var delegate = intervalProvider.delegate;
    return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
  },
  delegate: undefined
};

var AsyncAction = function (_super) {
  __extends(AsyncAction, _super);
  function AsyncAction(scheduler, work) {
    var _this = _super.call(this, scheduler, work) || this;
    _this.scheduler = scheduler;
    _this.work = work;
    _this.pending = false;
    return _this;
  }
  AsyncAction.prototype.schedule = function (state, delay) {
    var _a;
    if (delay === void 0) {
      delay = 0;
    }
    if (this.closed) {
      return this;
    }
    this.state = state;
    var id = this.id;
    var scheduler = this.scheduler;
    if (id != null) {
      this.id = this.recycleAsyncId(scheduler, id, delay);
    }
    this.pending = true;
    this.delay = delay;
    this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
    return this;
  };
  AsyncAction.prototype.requestAsyncId = function (scheduler, _id, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    return intervalProvider.setInterval(scheduler.flush.bind(scheduler, this), delay);
  };
  AsyncAction.prototype.recycleAsyncId = function (_scheduler, id, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    if (delay != null && this.delay === delay && this.pending === false) {
      return id;
    }
    if (id != null) {
      intervalProvider.clearInterval(id);
    }
    return undefined;
  };
  AsyncAction.prototype.execute = function (state, delay) {
    if (this.closed) {
      return new Error('executing a cancelled action');
    }
    this.pending = false;
    var error = this._execute(state, delay);
    if (error) {
      return error;
    } else if (this.pending === false && this.id != null) {
      this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    }
  };
  AsyncAction.prototype._execute = function (state, _delay) {
    var errored = false;
    var errorValue;
    try {
      this.work(state);
    } catch (e) {
      errored = true;
      errorValue = e ? e : new Error('Scheduled action threw falsy error');
    }
    if (errored) {
      this.unsubscribe();
      return errorValue;
    }
  };
  AsyncAction.prototype.unsubscribe = function () {
    if (!this.closed) {
      var _a = this,
        id = _a.id,
        scheduler = _a.scheduler;
      var actions = scheduler.actions;
      this.work = this.state = this.scheduler = null;
      this.pending = false;
      arrRemove(actions, this);
      if (id != null) {
        this.id = this.recycleAsyncId(scheduler, id, null);
      }
      this.delay = null;
      _super.prototype.unsubscribe.call(this);
    }
  };
  return AsyncAction;
}(Action);

var Scheduler = function () {
  function Scheduler(schedulerActionCtor, now) {
    if (now === void 0) {
      now = Scheduler.now;
    }
    this.schedulerActionCtor = schedulerActionCtor;
    this.now = now;
  }
  Scheduler.prototype.schedule = function (work, delay, state) {
    if (delay === void 0) {
      delay = 0;
    }
    return new this.schedulerActionCtor(this, work).schedule(state, delay);
  };
  Scheduler.now = dateTimestampProvider.now;
  return Scheduler;
}();

var AsyncScheduler = function (_super) {
  __extends(AsyncScheduler, _super);
  function AsyncScheduler(SchedulerAction, now) {
    if (now === void 0) {
      now = Scheduler.now;
    }
    var _this = _super.call(this, SchedulerAction, now) || this;
    _this.actions = [];
    _this._active = false;
    return _this;
  }
  AsyncScheduler.prototype.flush = function (action) {
    var actions = this.actions;
    if (this._active) {
      actions.push(action);
      return;
    }
    var error;
    this._active = true;
    do {
      if (error = action.execute(action.state, action.delay)) {
        break;
      }
    } while (action = actions.shift());
    this._active = false;
    if (error) {
      while (action = actions.shift()) {
        action.unsubscribe();
      }
      throw error;
    }
  };
  return AsyncScheduler;
}(Scheduler);

var asyncScheduler = new AsyncScheduler(AsyncAction);
var async = asyncScheduler;

function isScheduler(value) {
  return isFunction(value.schedule);
}

var isArrayLike = function (x) {
  return x && typeof x.length === 'number' && typeof x !== 'function';
};

function isPromise(value) {
  return isFunction(value === null || value === void 0 ? void 0 : value.then);
}

function isInteropObservable(input) {
  return isFunction(input[observable]);
}

function isAsyncIterable(obj) {
  return Symbol.asyncIterator && isFunction(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

function createInvalidObservableTypeError(input) {
  return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

function getSymbolIterator() {
  if (typeof Symbol !== 'function' || !Symbol.iterator) {
    return '@@iterator';
  }
  return Symbol.iterator;
}
var iterator = getSymbolIterator();

function isIterable(input) {
  return isFunction(input === null || input === void 0 ? void 0 : input[iterator]);
}

function readableStreamLikeToAsyncGenerator(readableStream) {
  return __asyncGenerator(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
    var reader, _a, value, done;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          reader = readableStream.getReader();
          _b.label = 1;
        case 1:
          _b.trys.push([1,, 9, 10]);
          _b.label = 2;
        case 2:
          return [4, __await(reader.read())];
        case 3:
          _a = _b.sent(), value = _a.value, done = _a.done;
          if (!done) return [3, 5];
          return [4, __await(void 0)];
        case 4:
          return [2, _b.sent()];
        case 5:
          return [4, __await(value)];
        case 6:
          return [4, _b.sent()];
        case 7:
          _b.sent();
          return [3, 2];
        case 8:
          return [3, 10];
        case 9:
          reader.releaseLock();
          return [7];
        case 10:
          return [2];
      }
    });
  });
}
function isReadableStreamLike(obj) {
  return isFunction(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

function innerFrom(input) {
  if (input instanceof Observable) {
    return input;
  }
  if (input != null) {
    if (isInteropObservable(input)) {
      return fromInteropObservable(input);
    }
    if (isArrayLike(input)) {
      return fromArrayLike(input);
    }
    if (isPromise(input)) {
      return fromPromise(input);
    }
    if (isAsyncIterable(input)) {
      return fromAsyncIterable(input);
    }
    if (isIterable(input)) {
      return fromIterable(input);
    }
    if (isReadableStreamLike(input)) {
      return fromReadableStreamLike(input);
    }
  }
  throw createInvalidObservableTypeError(input);
}
function fromInteropObservable(obj) {
  return new Observable(function (subscriber) {
    var obs = obj[observable]();
    if (isFunction(obs.subscribe)) {
      return obs.subscribe(subscriber);
    }
    throw new TypeError('Provided object does not correctly implement Symbol.observable');
  });
}
function fromArrayLike(array) {
  return new Observable(function (subscriber) {
    for (var i = 0; i < array.length && !subscriber.closed; i++) {
      subscriber.next(array[i]);
    }
    subscriber.complete();
  });
}
function fromPromise(promise) {
  return new Observable(function (subscriber) {
    promise.then(function (value) {
      if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
      }
    }, function (err) {
      return subscriber.error(err);
    }).then(null, reportUnhandledError);
  });
}
function fromIterable(iterable) {
  return new Observable(function (subscriber) {
    var e_1, _a;
    try {
      for (var iterable_1 = __values(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()) {
        var value = iterable_1_1.value;
        subscriber.next(value);
        if (subscriber.closed) {
          return;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    subscriber.complete();
  });
}
function fromAsyncIterable(asyncIterable) {
  return new Observable(function (subscriber) {
    process$1(asyncIterable, subscriber).catch(function (err) {
      return subscriber.error(err);
    });
  });
}
function fromReadableStreamLike(readableStream) {
  return fromAsyncIterable(readableStreamLikeToAsyncGenerator(readableStream));
}
function process$1(asyncIterable, subscriber) {
  var asyncIterable_1, asyncIterable_1_1;
  var e_2, _a;
  return __awaiter(this, void 0, void 0, function () {
    var value, e_2_1;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 5, 6, 11]);
          asyncIterable_1 = __asyncValues(asyncIterable);
          _b.label = 1;
        case 1:
          return [4, asyncIterable_1.next()];
        case 2:
          if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [3, 4];
          value = asyncIterable_1_1.value;
          subscriber.next(value);
          if (subscriber.closed) {
            return [2];
          }
          _b.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          e_2_1 = _b.sent();
          e_2 = {
            error: e_2_1
          };
          return [3, 11];
        case 6:
          _b.trys.push([6,, 9, 10]);
          if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [3, 8];
          return [4, _a.call(asyncIterable_1)];
        case 7:
          _b.sent();
          _b.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (e_2) throw e_2.error;
          return [7];
        case 10:
          return [7];
        case 11:
          subscriber.complete();
          return [2];
      }
    });
  });
}

function isValidDate(value) {
  return value instanceof Date && !isNaN(value);
}

function timer(dueTime, intervalOrScheduler, scheduler) {
  if (scheduler === void 0) {
    scheduler = async;
  }
  var intervalDuration = -1;
  {
    if (isScheduler(intervalOrScheduler)) {
      scheduler = intervalOrScheduler;
    } else {
      intervalDuration = intervalOrScheduler;
    }
  }
  return new Observable(function (subscriber) {
    var due = isValidDate(dueTime) ? +dueTime - scheduler.now() : dueTime;
    if (due < 0) {
      due = 0;
    }
    var n = 0;
    return scheduler.schedule(function () {
      if (!subscriber.closed) {
        subscriber.next(n++);
        if (0 <= intervalDuration) {
          this.schedule(undefined, intervalDuration);
        } else {
          subscriber.complete();
        }
      }
    }, due);
  });
}

function interval(period, scheduler) {
  if (scheduler === void 0) {
    scheduler = asyncScheduler;
  }
  return timer(period, period, scheduler);
}

function throttle(durationSelector, config) {
  return operate(function (source, subscriber) {
    var _a = config !== null && config !== void 0 ? config : {},
      _b = _a.leading,
      leading = _b === void 0 ? true : _b,
      _c = _a.trailing,
      trailing = _c === void 0 ? false : _c;
    var hasValue = false;
    var sendValue = null;
    var throttled = null;
    var isComplete = false;
    var endThrottling = function () {
      throttled === null || throttled === void 0 ? void 0 : throttled.unsubscribe();
      throttled = null;
      if (trailing) {
        send();
        isComplete && subscriber.complete();
      }
    };
    var cleanupThrottling = function () {
      throttled = null;
      isComplete && subscriber.complete();
    };
    var startThrottle = function (value) {
      return throttled = innerFrom(durationSelector(value)).subscribe(createOperatorSubscriber(subscriber, endThrottling, cleanupThrottling));
    };
    var send = function () {
      if (hasValue) {
        hasValue = false;
        var value = sendValue;
        sendValue = null;
        subscriber.next(value);
        !isComplete && startThrottle(value);
      }
    };
    source.subscribe(createOperatorSubscriber(subscriber, function (value) {
      hasValue = true;
      sendValue = value;
      !(throttled && !throttled.closed) && (leading ? send() : startThrottle(value));
    }, function () {
      isComplete = true;
      !(trailing && hasValue && throttled && !throttled.closed) && subscriber.complete();
    }));
  });
}

var LoadedState;
(function (LoadedState) {
  LoadedState["LOADING"] = "LOADING";
  LoadedState["LOADED"] = "LOADED";
  LoadedState["NOT_LOADED"] = "NOT_LOADED";
  LoadedState["FAILED_TO_LOAD_IN_BROWSER"] = "FAILED_TO_LOAD_IN_BROWSER";
})(LoadedState || (LoadedState = {}));
var ReadyState;
(function (ReadyState) {
  ReadyState["READY"] = "READY";
  ReadyState["NOT_READY"] = "NOT_READY";
})(ReadyState || (ReadyState = {}));

const waitFor = ms => __awaiter(void 0, void 0, void 0, function* () {
  return new Promise(resolve => setTimeout(resolve, ms));
});
const timeoutByConnection = () => __awaiter(void 0, void 0, void 0, function* () {
  const connection = window.navigator.connection;
  let timeout;
  switch (connection === null || connection === void 0 ? void 0 : connection.effectiveType) {
    case '2g':
      timeout = 27500;
      break;
    case '3g':
      timeout = 9500;
      break;
    case '4g':
      timeout = 3000;
      break;
    default:
      timeout = 45000;
  }
  return waitFor(timeout);
});

const state$1 = {
  loadedState: LoadedState.NOT_LOADED,
  readyState: ReadyState.NOT_READY
};
let onReadyResolver;
const onReadyPromise = new Promise(resolve => {
  onReadyResolver = resolve;
});
const waitForReadyOrTimeout = () => Promise.race([timeoutByConnection(), onReadyPromise]);
const onReady = () => {
  state$1.readyState = ReadyState.READY;
  onReadyResolver();
};
const onLoadedStateChanged = loadedState => {
  state$1.loadedState = loadedState;
};
const initTracker = (configInner, attributes, transport, route, retryLoading) => {
  var _a, _b, _c;
  const win = window;
  win.dataLayer = win.dataLayer || [];
  if ((_a = win === null || win === void 0 ? void 0 : win.pulse) === null || _a === void 0 ? void 0 : _a.init) {
    (_b = win === null || win === void 0 ? void 0 : win.pulse) === null || _b === void 0 ? void 0 : _b.init(configInner, attributes, transport, route);
  } else if (!((_c = win === null || win === void 0 ? void 0 : win.pulse) === null || _c === void 0 ? void 0 : _c.tracker)) {
    waitForReadyOrTimeout().then(() => __awaiter(void 0, void 0, void 0, function* () {
      if (state$1.loadedState === LoadedState.FAILED_TO_LOAD_IN_BROWSER) {
        retryLoading();
      }
    }));
  }
};

function getScriptHost() {
  var _a, _b, _c, _d;
  const host = ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.document) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.ancestorOrigins) === null || _c === void 0 ? void 0 : _c[0]) || ((_d = window === null || window === void 0 ? void 0 : window.location) === null || _d === void 0 ? void 0 : _d.host);
  if (/(localhost|127\.0\.0\.1):9000/.test(host)) {
    // Local development of the SDK
    return 'http://localhost:8585';
  }
  if (/localhost:3000/.test(host)) {
    // Development
    return 'https://dev.optifyr.com';
  }
  if (/([^.]+\.)*picsartstage2\.com/.test(host) || /([^.]+\.)+sdk\.picsart\.io/.test(host) || /([^.]+\.)+admaker\.pages\.dev(:\d+)?/.test(host) || /^https?:\/\/tools-preprod\.picsart\.com(:\d+)?/i.test(host) || /localhost/.test(host) || /127\.0\.0\.1/.test(host)) {
    // Staging
    return 'https://stage.optifyr.com';
  }
  // Production
  return 'https://optifyr.com';
}
function loadBrowserSdk(app) {
  const win = window;
  win.dynamic = win.dynamic || {};
  const scriptModule = document.createElement('script');
  const scriptNomodule = document.createElement('script');
  const defaultHost = getScriptHost();
  scriptModule.type = 'text/javascript';
  scriptModule.async = true;
  scriptModule.fetchPriority = 'high';
  scriptNomodule.type = 'text/javascript';
  scriptNomodule.async = true;
  scriptNomodule.fetchPriority = 'high';
  scriptModule.type = 'module';
  scriptModule.src = "".concat(defaultHost, "/pulse/mini/v1/").concat(app, "/module/pulse.js");
  scriptNomodule.noModule = true;
  scriptNomodule.src = "".concat(defaultHost, "/pulse/mini/v1/").concat(app, "/nomodule/pulse.js");
  return new Promise((resolve, reject) => {
    scriptModule.onload = resolve;
    scriptModule.onerror = reject;
    scriptNomodule.onload = resolve;
    scriptNomodule.onerror = reject;
    document.head.appendChild(scriptModule);
    document.head.appendChild(scriptNomodule);
  });
}

const state = {
  app: '',
  app_version: '0',
  sdk: {
    state: state$1,
    onLoadingStateChanged: onLoadedStateChanged,
    init: initTracker,
    onReady: onReady
  }
};
const retryLoad$ = new Subject();
const retryLoad = retryLoad$.pipe(throttle(() => interval(100))).subscribe(() => {
  loadBrowserSdk(state.app).catch(err => {
    console.log(err);
  });
});
function retryLoadSDK() {
  retryLoad$.next(true);
}
function sdkScriptsAdded() {
  let added = false;
  const script = checkIfScriptExists();
  if (script) {
    added = true;
  }
  return added;
}
function checkIfScriptExists() {
  const scripts = document.getElementsByTagName('script');
  for (let i = 0; i < scripts.length; i++) {
    const script = scripts[i];
    const src = script.getAttribute('src');
    if (src && src.match(/^(https?|http):\/\/[^/]+\/pulse\/[^/]+\/mini\/[^/]+\/v1\/[^/]+\/(module\/|nomodule\/)?pulse\.js/i)) {
      return true;
    }
  }
  return false;
}
const setFailedState = () => {
  return () => {
    var _a, _b;
    (_b = (_a = state.sdk).onLoadingStateChanged) === null || _b === void 0 ? void 0 : _b.call(_a, LoadedState.FAILED_TO_LOAD_IN_BROWSER);
  };
};
function setLoadedState() {
  var _a, _b;
  (_b = (_a = state.sdk).onLoadingStateChanged) === null || _b === void 0 ? void 0 : _b.call(_a, LoadedState.LOADED);
}
const initialize = _ref => {
  let {
    config,
    attributes,
    transport,
    route
  } = _ref;
  var _a, _b;
  if (!transport) {
    throw new Error("You can't init the Pulse SDK without providing transport function!");
  }
  if (!route) {
    throw new Error("You can't init the Pulse SDK without providing route object!");
  }
  if (!state.app) {
    state.app = attributes.appName;
  }
  if (state.app_version === '0' && attributes.miniAppVersion) {
    state.app_version = attributes.miniAppVersion;
  }
  const win = window;
  win.pulseReady = win.pulseReady || [];
  win.dataLayer = win.dataLayer || [];
  if (win.pulseFailedToLoad && !((_a = win === null || win === void 0 ? void 0 : win.pulse) === null || _a === void 0 ? void 0 : _a.tracker)) {
    setFailedState()();
  } else if (win.pulseFailedToLoad === undefined && !((_b = win === null || win === void 0 ? void 0 : win.pulse) === null || _b === void 0 ? void 0 : _b.tracker)) {
    win.document.addEventListener('pulseLoadFailed', setFailedState());
  }
  win.pulseReady.push({
    onReady: () => {
      state.sdk.init(config.tracker || {}, attributes, transport, route, () => retryLoadSDK());
      win.document.removeEventListener('pulseLoadFailed', setFailedState());
      retryLoad.unsubscribe();
      retryLoad$.complete();
      state.sdk.onReady();
    }
  });
  if (!sdkScriptsAdded()) {
    win.document.removeEventListener('pulseLoadFailed', setFailedState());
    const script = loadBrowserSdk(state.app);
    script.then(() => {
      setLoadedState();
    }).catch(() => {
      setFailedState()();
    });
  }
  return {
    tracker: state.sdk.init(config.tracker || {}, attributes, transport, route, () => retryLoadSDK())
  };
};

const initAnalytics = context => {
  const miniapp = internalContext.miniapp;
  const locationWithStringParams = createVirtualModel({
    models: [context.general.location],
    handler: _ref => {
      let {
        params,
        ...location
      } = _ref;
      return {
        ...location,
        params: convertObjectIntoQuerySearch(params)
      };
    },
    options: {}
  });
  initialize({
    config: {
      tracker: {}
    },
    attributes: {
      miniAppName: miniapp.name,
      miniAppId: miniapp.packageId,
      miniAppVersion: miniapp.appVersion,
      appName: internalContext.hostName
    },
    transport: data => sendAnalytics({
      data
    }),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    route: locationWithStringParams
  });
};

let context = {};
const getContext = () => context;
logger(mainLogs.initializing);
context = createBaseContext();
runListeners(context);
bootstraper(async (payload, cb) => {
  var _payload$platform;
  internalContext.miniapp = payload.miniapp;
  internalContext.hostName = payload.hostName;
  initAnalytics(context);
  logger(mainLogs.bootstrap);
  cb();
  handleContextChange(payload, context);
  updateState(context, payload.state);
  logger(mainLogs.context);
  internalContext.bootstrapCame = true;
  logger(mainLogs.open);
  await postOpenHandler((_payload$platform = payload.platform) === null || _payload$platform === void 0 || (_payload$platform = _payload$platform.TTI) === null || _payload$platform === void 0 ? void 0 : _payload$platform.loadStartTimestamp);
  authRedirectListener();
  context.handlers.onClose(() => {
    logger("".concat(mainLogs.close, ":::"));
  });
});

export { getContext };
